import React, { useState, useEffect, useMemo } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import _, { isEmpty, get, cloneDeep } from "lodash";
import DatePickerT from "react-datepicker";
import { Button, message, Steps, theme, Tabs, Checkbox } from 'antd';
import moment from 'moment';
// import { DatePicker } from 'antd';
import { dayOfWeekMap, formFields, formFeildsDayPart, formFeildfacebookPageList, formFeildsAgeFromTo, formFeildAge } from "./constant";
import Input from "../../../../../../components/FormElements/Input";
import Select from "react-select";
import SelectNew from "../../../../../../components/FormElements/SelectNew";
import SearchSelect from "../../../../../../components/FormElements/SearchSelect";
import LocationSelect from "../../../../../../components/FormElements/LocationSelect";
import DatepickerD from "../../../../../../components/FormElements/Datepicker";
import adwords from '../../../../../../assets/images/adwords.png';
import meta from '../../../../../../assets/images/meta.png';
import dv360 from '../../../../../../assets/images/dv360.png';
import tiktok from '../../../../../../assets/images/tiktok.png';
import IONLogo from '../../../../../../assets/images/ion.png';
import ViLogo from '../../../../../../assets/images/platformWhiteBgIcons/1x-Icons/vodafone.png'; 
import {
  handleFieldError,
  handleError,
} from "../../../../../../utils/form-validation";
import { CSSTransition } from "react-transition-group";

import {
  getCategoryAction,
  getSUbCategoryAction,
  getDataConfigAction,
  getLanguageAction,
  getLocationAction,
  getAudienceAction,
  getThirdPartyAccountAction,
  postAddNewStrategyAction,
  dataConfigV2Action,
  pageListAction
} from "../../../../../../actions";

import { useFetchPlatformData } from "../../../../../../hooks/useFetchPlatformData";
import { setLocationReduxAction, strategyListReduxAction } from "../../../../../../actions/strategyDetails";
import { configKeys } from "../../../../../../helpers/config/configKeys";

const Strategy = (props) => {
  console.log("props", props)
  const { TabPane } = Tabs;


  console.log("props", props)
  // Create state variables for input values
  const platformData = useFetchPlatformData();
  const [touched, setTouched] = useState({});
  const [errors, setErrors] = useState({
    /* initial errors state */
  });
  const [submited, setSubmited] = useState(false);
  const [form, setForm] = useState({});
  const [categoryData, setCategoryData] = useState([]);
  const [seatData, setSeatData] = useState([]);
  const [fbPageData, setFbPageData] = useState([]);
  const [languageData, setLanguageData] = useState([]);
  const [durationData, setDurationData] = useState([]);
  const [objectiveData, setObjectiveData] = useState([]);
  const [audData, setaudData] = useState([]);
  const [listAudienceData, setListAudience] = useState([]);
  const [selectedTab, setSelectedTab] = useState(audData.length > 0 ? audData[0] : null);
  const [responseBySearchTerm, setResponseBySearchTerm] = useState({});
  const [selectedAudienceState, setSelectedAudienceState] = useState({});
  const [locationPayload, setLocationPayload] = useState([]);
  const [strategyId, setStrategyId] = useState({});
  const [keywordsData, setKeywordsData] = useState([]);
  const [sitesData, setSitesData] = useState([]);
  const [genderData, setGenderData] = useState([]);
  const [pacingData, setPacingData] = useState([]);
  const [biddingStrategy, setBiddingStrategyData] = useState([]);
  const [deviceData, setDeviceData] = useState([]);
  const [ageRangeData, setAgeRangeData] = useState([]);
  const [showFrequencyForm, setShowFrequencyForm] = useState(false);
  const [showLocationForm, setShowLocationForm] = useState(false);
  const [showAudienceForm, setShowAudienceForm] = useState(false);
  const [showKeywordsForm, setShowKeywordsForm] = useState(false);
  const [showSitesForm, setShowSitesForm] = useState(false);
  const [showFlightForm, setShowFlightForm] = useState(false);
  const [showPageForm, setShowPageForm] = useState(false);
  const [showOnScreenPositionForm, setShowOnScreenPositionForm] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState([]);
  const [selectedAudience, setSelectedAudience] = useState([]);
  const [selectedKeywords, setSelectedKeywords] = useState([]);
  const [selectedSites, setSelectedSites] = useState([]);
  const [selectedOptionFrequency, setSelectedOptionFrequency] = useState("none"); // You can initialize this state based on your requirements
  const [selectedOption, setSelectedOption] = useState("allDatesAndDayParts"); // You can initialize this state based on your requirements
  const [selectedOptionSites, setSelectedOptionSites] = useState("whiteList");
  const [selectedOnScreenPositionDetails, setSelectedOnScreenPositionDetails] = useState([]);
  const [showFbOptions, setShowFbOptions] = useState(false);
  const [showDvOptions, setShowDvOptions] = useState(false);

  const [customSchedules, setCustomSchedules] = useState([]);
  const [selectedDays, setSelectedDays] = useState([]);
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [dayparts, setDayparts] = useState([
    {
      startTime: "",
      endTime: "",
      selectedDays: [],
      startDate: "",
      endDate: "",
    },
  ]);

  const [selectAllGoogleAdWords, setSelectAllGoogleAdWords] = useState(false);
  const [selectAllMeta, setSelectAllMeta] = useState(false);
  const [locationData, setLocationData] = useState([]);
  const [audienceData, setAudienceData] = useState([]);
  const [ageFromOptions, setAgeFromOptions] = useState([]);
  const [ageToOptions, setAgeToOptions] = useState([]);
  const [selectedAgeFrom, setSelectedAgeFrom] = useState(null);
  const [selectedDevices, setDevice] = useState([]);
  const [onScreenData, setOnScreenData] = useState([]);
  const [onScreenPositionDetails, setOnScreenPositionDetails] = useState({
    metaOnScreenPositionOptions: [],
    metaManualPositionOptions: {
      feeds: { key: 'OnScreen_Position_Facebook_Feeds', title: 'Feeds', list: [] },
      stories: { key: 'OnScreen_Position_Facebook_Stories_And_Reels', title: 'Stories and Reels', list: [] },
      search: { key: 'OnScreen_Position_Facebook_Search_Results', title: 'Search Results', list: [] }
    },
    dv360PositionOptions: {
      onScreen: {
        display: { key: 'OnScreen_Position_DV360_Screen_Position_Display', list: [], title: 'Display' },
        video: { key: 'OnScreen_Position_DV360_Screen_Position_Video', list: [], title: 'Video' },
      },
      inContent: {
        inDisplay: { key: 'OnScreen_Position_DV360_Content_Position_Display', list: [], title: 'Display' },
        videoInStream: { key: 'OnScreen_Position_DV360_Conent_Position_Video_InStream', list: [], title: 'Video in-stream' },
        videoOutStream: { key: 'OnScreen_Position_DV360_Conent_Position_Video_OutStream', list: [], title: 'Video out-stream' }
      }
    },
    ionViAdsOnScreenPositionOptions:[],
  });

  console.log("selectedDevices", selectedDevices)
  console.log("selectedOptionSites", selectedOptionSites)

  const tenantId = useSelector((state) =>
    get(state, "app.preSignInState.tenantId", "")
  );
  const userId = useSelector((state) =>
    get(state, "app.preSignInData.userId", "")
  );
  const authToken = useSelector((state) =>
    get(state, "app.signInData.authToken", "")
  );
  const basicDetailsForm = useSelector(state => get(state, 'app.basicDetailsForm', {}));


  const creativeMappingKeys = { 0: ['display'], 1: ['video'], 2: ['search'], 3: ['display', 'video'] };
  const dispatch = useDispatch();

  const handleAddRow = () => {
    setDayparts((prevDayparts) => [
      ...prevDayparts,
      {
        startTime: "",
        endTime: "",
        selectedDays: [],
        startDate: "",
        endDate: "",
      },
    ]);
  };

  const handleDeleteRow = (index) => {
    setDayparts((prevDayparts) => {
      const updatedDayparts = [...prevDayparts];
      updatedDayparts.splice(index, 1);
      return updatedDayparts;
    });
  };

  const handleTimeChange = (index, timeType, value) => {
    setDayparts((prevDayparts) => {
      const updatedDayparts = [...prevDayparts];

      if (timeType == "startDate" || timeType == "endDate") {
        if (timeType == "startDate") {
          if (value.target.value > updatedDayparts[index].endDate) {
            updatedDayparts[index].endDate = ''
          }
        }
        else {
          if (value.target.value < updatedDayparts[index].startDate) {
            updatedDayparts[index].startDate = ''
          }
        }
        // Assuming you want to get the value from the target property
        updatedDayparts[index][timeType] = value.target.value;
      } else {
        // If it's not "start date" or "end date", directly set the value
        updatedDayparts[index][timeType] = value;
      }
      console.log("updatedDayparts", updatedDayparts);
      return updatedDayparts;
    });
  };

  // const handleDayChange = (index, day) => {
  //   setDayparts((prevDayparts) => {
  //     const updatedDayparts = [...prevDayparts];
  //     updatedDayparts[index].selectedDays = day;
  //     return updatedDayparts;
  //   });
  // };

  const handleDayChange = (index, day) => {
    setDayparts((prevDayparts) => {
      const updatedDayparts = [...prevDayparts];
      const selectedDays = updatedDayparts[index].selectedDays || []; // Initialize as an array if not already
      const dayIndex = selectedDays.indexOf(day);

      if (dayIndex !== -1) {
        // If the day is already selected, remove it
        selectedDays.splice(dayIndex, 1);
      } else {
        // If the day is not selected, add it
        selectedDays.push(day);
      }

      updatedDayparts[index].selectedDays = selectedDays;
      return updatedDayparts;
    });
  };

  const handleSelectChange = (selectedOptions, formKey) => {
    if (formKey === "location") {
      // setSelectedLocation(selectedOptions);
    } else if (formKey === "audience") {
      setSelectedAudience(selectedOptions);
    } else if (formKey === "keywords") {
      setSelectedKeywords(selectedOptions);
    } else if (formKey === "sites") {
      setSelectedSites(selectedOptions);
    } else if (formKey === "device") {
      setDevice(selectedOptions);
    }
    else if(formKey === "onScreenPosition"){
      const updatedOptions = selectedOptions.map((data)=>({id:data.value,name:data.label}));
      setOnScreenData(updatedOptions);
    }
    // Add more conditions for other form keys if needed
  };

  // const handleCheckboxChange = (column, value) => {
  //   // Handle checkbox changes for each column
  //   if (column === 'googleAdWords') {
  //     // Handle Google AdWords checkbox changes
  //     setSelectAllGoogleAdWords(value);
  //   } else if (column === 'meta') {
  //     // Handle Meta checkbox changes
  //     setSelectAllMeta(value);
  //   }
  // };


  const handleCheckboxChange = (audienceId, checked) => {
    const newSelectedAudienceState = { ...selectedAudienceState };
    const selectedTabAudience = responseBySearchTerm[selectedTab] || [];

    // Update the individual checkbox state
    newSelectedAudienceState[selectedTab] = {
      ...newSelectedAudienceState[selectedTab],
      [audienceId]: checked,
    };

    // Check if all individual checkboxes are checked
    const allChecked = selectedTabAudience.every((option) => newSelectedAudienceState[selectedTab] && newSelectedAudienceState[selectedTab][option.id]);

    // Update the 'selectAll' checkbox state
    newSelectedAudienceState[selectedTab] = {
      ...newSelectedAudienceState[selectedTab],
      selectAll: allChecked,
    };

    setSelectedAudienceState(newSelectedAudienceState);
  };

  // const handleDayChange = (day) => {
  //   if (selectedDays.includes(day)) {
  //     // Remove the day if it's already selected
  //     setSelectedDays(selectedDays.filter(selectedDay => selectedDay !== day));
  //   } else {
  //     // Add the day if it's not selected
  //     setSelectedDays([...selectedDays, day]);
  //   }
  // };

  // // Function to handle time selection
  // const handleTimeChange = (timeType, selectedTime) => {
  //   if (timeType === 'start') {
  //     setStartTime(selectedTime);
  //   } else {
  //     setEndTime(selectedTime);
  //   }
  // };

  const isFormComplete = () => {
    // console.log(form);
    // Validate the form using the handleError function
    let { errors, valid } = handleError(form, formFields);

    // console.log("errors:", errors);
    // console.log("valid:", valid);

    // Check if the form is both complete and valid

    if (valid) {
      props.setBasicDetailsInParent(form);
    }

    return valid;
  };

  // Function to find the language value based on adwordsId
  const findLanguageValue = (languageConstants) => {
    console.log(languageData, 'LANGUAGE DATA');
    console.log(props.platformType, 'props.platformType');
    console.log(languageConstants, 'languageConstants');
    const mappingKeys = {
      'ads': 'adwordsId',
      'dv360': 'adwordsId',
      'meta': 'metaId',
      'tiktok': 'tiktokId',
      'ion': 'ionId',
      'viads':'viadsId'
      // Add more mappings as needed
    };

    // Get the mapping key based on the platformType
    const platformKey = mappingKeys[props.platformType];
    console.log("platformKey", platformKey)

    const language = languageData.find((item) => item[platformKey] == languageConstants);
    console.log("language", language)
    return language ? language.id : '';
  };

  const getOnScreenPositionDetails = async (data) => {
    if (data && data.response.length > 0) {
      const findPlatform = platformData.find((data) => data.value.toLowerCase().includes(props.platformType.toLowerCase()));
      if (props.platformType == "meta") {
        let metaOnScreenPositionOptions = data.response.reduce((accumulator, item) => {
          if (item.name == "Onscreen_Type" && item.platformId == findPlatform.key && item.list) {
            accumulator = item.list.map(subItem => ({ ...subItem, value: subItem.name, label: subItem.name }));
          }
          return accumulator;
        }, []);

        const { feeds, stories, search } = onScreenPositionDetails.metaManualPositionOptions;
        let metaManualOnScreenFeedOptions = data.response.find(item => item.name == feeds.key);
        let metaManualOnScreenStoriesOptions = data.response.find(item => item.name == stories.key);
        let metaManualOnScreenSearchOptions = data.response.find(item => item.name == search.key);

        setOnScreenPositionDetails({
          metaOnScreenPositionOptions: metaOnScreenPositionOptions,
          metaManualPositionOptions: {
            feeds: {
              ...onScreenPositionDetails.metaManualPositionOptions.feeds,
              list: metaManualOnScreenFeedOptions.list
            },
            stories: {
              ...onScreenPositionDetails.metaManualPositionOptions.stories,
              list: metaManualOnScreenStoriesOptions.list
            },
            search: {
              ...onScreenPositionDetails.metaManualPositionOptions.search,
              list: metaManualOnScreenSearchOptions.list
            },
          }
        });
      } else if (props.platformType == "dv360") {
        const { display, video } = onScreenPositionDetails.dv360PositionOptions.onScreen;
        const { inDisplay, videoInStream, videoOutStream } = onScreenPositionDetails.dv360PositionOptions.inContent;
        let dv360DisplayOnScreenOptions = data.response.find(item => item.name == display.key);
        let dv360VideoOnScreenOptions = data.response.find(item => item.name == video.key);
        let dv360DisplayInContentOptions = data.response.find(item => item.name == inDisplay.key);
        let dv360VideoInStreamInContentOptions = data.response.find(item => item.name == videoInStream.key);
        let dv360VideoOutStreamInContentOptions = data.response.find(item => item.name == videoOutStream.key);
        setOnScreenPositionDetails({
          ...onScreenPositionDetails,
          dv360PositionOptions: {
            onScreen: {
              display: {
                ...display,
                list: dv360DisplayOnScreenOptions.list
              },
              video: {
                ...video,
                list: dv360VideoOnScreenOptions.list
              },
            },
            inContent: {
              inDisplay: {
                ...inDisplay,
                list: dv360DisplayInContentOptions.list
              },
              videoInStream: {
                ...videoInStream,
                list: dv360VideoInStreamInContentOptions.list
              },
              videoOutStream: {
                ...videoOutStream,
                list: dv360VideoOutStreamInContentOptions.list
              }
            }
          }
        });
      }
      else if(props.platformType == "ion" || props.platformType == "viads"){
        const ionViScreenPosionDetails =  data.response.filter((onscreenIonVI)=>onscreenIonVI.name == configKeys.ONSCREEN_POSITION && findPlatform.key == onscreenIonVI.platformId);
       if(ionViScreenPosionDetails.length > 0 && ionViScreenPosionDetails[0].list && ionViScreenPosionDetails[0].list.length > 0){
        let optionsForIonPosition = ionViScreenPosionDetails[0].list.map((data)=>({label:data.name,value:data.id}));
        setOnScreenPositionDetails((prevData) => ({ ...prevData, ionViAdsOnScreenPositionOptions:optionsForIonPosition}))
      }
      }

      else {

      }
    }
    // console.log('HELLO WORLD!', data.response);
  };

  const handleOnScreenPositions = (item) => {
    console.log(item.id);
    let updatedData = onScreenData;
    const isItemPresent = updatedData.some(screenPosition => screenPosition.id == item.id);
    if (isItemPresent) {
      updatedData = updatedData.filter(screenPosition => screenPosition.id != item.id);
    } else {
      updatedData = updatedData.concat(item);
    }
    setOnScreenData(updatedData);
  };

  useEffect(() => {
    initializeListApiCall();

    if (props.setShowStepper) {
      props.setShowStepper(false);
    }

    if (props.screenType === "edit") {

      if (props.rowData.targeting && props.rowData.targeting.daypart && props.rowData.targeting.daypart.length > 0) {
        // console.log(props.rowData.targeting.daypart,'propsForDaypart')
        const dayPartDataToSet = props.rowData.targeting.daypart.map((data) => {
          const timeData = data.time.replaceAll(".", ":").split(',');
          const dayArray = getKeysByValues(dayOfWeekMap, data.day.split(','));
          // console.log(timeData ,'propsForDaypart');
          return {
            startTime: (timeData && timeData[0]) ? timeData[0] : '00:00',
            endTime: (timeData && timeData[1]) ? timeData[1] : '00:00',
            selectedDays: dayArray,
            startDate: data.startDate ? moment(data.startDate).toDate() : '',
            endDate: data.endDate ? moment(data.endDate).toDate() : '',
          }
        })
        console.log(dayPartDataToSet, 'propsForDaypart');
        setDayparts(dayPartDataToSet);
        setSelectedOption("customSchedules")
        setShowFlightForm(true);
      }
      else {
        setSelectedOption("allDatesAndDayParts")
        // setShowFlightForm(true);
      }

      const languageConstants = props.rowData.targeting &&  props.rowData.targeting.language && props.rowData.targeting.language[props.platformType]
      console.log("languageConstants", languageConstants)

      const mappedPositionData = props.rowData.targeting && props.rowData.targeting.position
        ? props.rowData.targeting.position.map(item => ({ id: item.key, name: item.value }))
        : [];
      console.log("mappedPositionData", mappedPositionData)
      if (mappedPositionData && mappedPositionData.length > 0) {
        if (props.platformType === 'meta') {
          form[formFields.onScreenFb.key] = 'Manual';
          setShowFbOptions(true);
        }
        setShowOnScreenPositionForm(true);
        setOnScreenData(mappedPositionData);
      }

      const mappedDeviceData = props.rowData.targeting && props.rowData.targeting.device
        ? props.rowData.targeting.device.map(item => ({ label: item.value, value: item.value, id: item.key }))
        : [];
      console.log("mappedDeviceData", mappedDeviceData)
      setDevice(mappedDeviceData)
      // form.device = mappedDeviceData;

      const locationData = props.rowData.targeting && props.rowData.targeting.location ? props.rowData.targeting.location : [];
      console.log("locationData", locationData)
      setLocationPayload(locationData)
      if (locationData.length > 0) {
        setShowLocationForm(true) // Open Location if locationData is present
      }
      const includeLocations = locationData.filter(location => location.inex === 1);
      const excludeLocations = locationData.filter(location => location.inex === 0);

      // Function to create selection objects
      const createSelectionObject = location => ({
        label: location.value,
        value: location[props.platformType],
      });

      // Map location data for include selections
      const includeSelections = includeLocations.map(createSelectionObject);

      // Map location data for exclude selections
      const excludeSelections = excludeLocations.map(createSelectionObject);

      // Example output
      console.log("Include Selections:", includeSelections);
      console.log("Exclude Selections:", excludeSelections);
      dispatch(
        setLocationReduxAction({
          includedLocation: includeSelections,
          excludedLocation: excludeSelections
        })
      );

      const sitesEditData = props.rowData.targeting && props.rowData.targeting.sites ? props.rowData.targeting.sites.values : [];
      const isWhiteList = props.rowData.targeting && props.rowData.targeting.sites && props.rowData.targeting.sites.inex ? props.rowData.targeting.sites.inex == "1" : false ;
      if (sitesEditData && sitesEditData.length > 0) {
        const selectedSitesOptionsData = props.rowData.targeting && props.rowData.targeting.sites ? props.rowData.targeting.sites.inex : '';
        setSitesData(sitesEditData)
        console.log("selectedSitesOptionsData", selectedSitesOptionsData)
        setSelectedOptionSites(isWhiteList ? "whiteList" : "blackList")
        setShowSitesForm(true)
      }



      const audienceDataEdit = props.rowData.targeting && props.rowData.targeting.audience ? props.rowData.targeting.audience : [];
      console.log("audienceDataEdit", audienceDataEdit)
      let dataAudienceCloned = cloneDeep(audData);
      audienceDataEdit.forEach((item) => {
        if (!dataAudienceCloned.includes(item.value)) {
          dataAudienceCloned.push(item.value);
          audienceApiFunction(item.value);
        }
        console.log(dataAudienceCloned, 'dataAudienceCloned');
        setaudData(dataAudienceCloned);
        setForm((prevForm) => ({ ...prevForm, ["audience"]: '' }));
        setSelectedTab(item.value);
        if (audienceDataEdit.length > 0) {
          setShowAudienceForm(true)
        }


        // handleCheckboxChange(item[props.platformType], true)
        // const criterionId = item[props.platformType];
        // console.log("criterionId",criterionId)
        // console.log("cr responseBySearchTerm[item.value]",responseBySearchTerm)
        // console.log("cr responseBySearchTerm[item.value]",item.value)
        // const matchingOption = responseBySearchTerm && responseBySearchTerm[item.value] && responseBySearchTerm[item.value].find((option) => option.criterionId == criterionId);
        // console.log("matchingOption",matchingOption)
      });


      const keyWordData = props.rowData.targeting && props.rowData.targeting.keywords && props.rowData.targeting.keywords.values ? props.rowData.targeting.keywords.values : [];

      // setKeywordsData(keyWordData)
      if (keyWordData && Array.isArray(keyWordData) && keyWordData.length > 0) {
        setKeywordsData(keyWordData);
        setShowKeywordsForm(true);
      }


      console.log("222 props.rowData", props.rowData);
      const freqCap = props.rowData.freqCap && props.rowData.freqCap
      if (freqCap) {
        setSelectedOptionFrequency("limited")
        form.frequencyCapPerInterval = freqCap.interval
        form.frequencyCapTime = freqCap.time
        form.frequencyCapTo = freqCap.cap
        setShowFrequencyForm(true)
        if (props.platformType == "dv360") {
          calculateFrequencyCapTime(freqCap.interval)
        }
      }

      else {
        setSelectedOptionFrequency("none")
      }

      form.sDate = props.rowData.startDate ? moment(props.rowData.startDate).toDate() : props.rowData.sDate ? moment(props.rowData.sDate).toDate() : '';
      form.eDate = props.rowData.endDate ? moment(props.rowData.endDate).toDate() : props.rowData.eDate ? moment(props.rowData.eDate).toDate() : '';
      form.budget = props.rowData.budget;
      form.strategyName = props.rowData.name;
      form.biddingStrategy = props.rowData.bidStrategy && props.rowData.bidStrategy !== '0' ? props.rowData.bidStrategy : '';
      form.pacing = props.rowData.pacingType;
      form.duration = props.rowData.duration;
      form.budget = props.rowData.budget;
      form.gender = props.rowData.targeting && props.rowData.targeting.gender && props.rowData.targeting.gender[0] && props.rowData.targeting.gender[0].key || '';

      if (props.platformType === 'ads' || props.platformType === 'dv360') {
        form.ageGoogleAds = props.rowData.targeting && props.rowData.targeting.age || '';
      }
      setForm((prevForm) => {
        return {
          ...prevForm,
          ...form
        }
      })
    }
    if (props.screenType === "add") {
      dispatch(
        setLocationReduxAction({
          includedLocation: [],
          excludedLocation: []
        })
      );
    }
    if (props.platformType != 'dv360') {
      formFields.frequencyCapTime.min = 1;
      formFields.frequencyCapTime.max = 999;
    }
    if(props.platformType == 'meta')
    {
      setShowLocationForm(true)
      setShowPageForm(true)
    }
    if (props.platformType == 'ion' || props.platformType == "viads") {
      formFields.frequencyCapTo.min = 0;
      formFields.frequencyCapTo.max = 99999999;
    }
  }, []);

  useEffect(() => {
    if (props.rowData && props.rowData.targeting && props.rowData.targeting.age && !isNaN(props.rowData.targeting.age)) {
      const filteredAgeRangeData = ageRangeData.filter(item => item.id == props.rowData.targeting.age);

      if (filteredAgeRangeData.length > 0) {
        const selectedAgeFrom = parseInt(filteredAgeRangeData[0].name.split('-')[0]);
        const selectedAgeTo = parseInt(filteredAgeRangeData[0].name.split('-')[1]);

        setForm((prevForm) => {
          return {
            ...prevForm,
            [formFeildsAgeFromTo.ageFrom.key]: selectedAgeFrom.toString(),
            [formFeildsAgeFromTo.ageTo.key]: selectedAgeTo.toString(),
          }
        })
        setSelectedAgeFrom(selectedAgeFrom); // used to set ageFromOptions with useEffect below


      }
    }
  }, [ageRangeData]);

  useEffect(() => {
    if (props.rowData && props.rowData.accountId) {
      const accountValue = props.rowData.accountId
      let fbPageAccount = accountValue;
      let fbPageList = props.rowData.targeting && props.rowData.targeting.pageId || '';

      setForm((prevForm) => {
        return {
          ...prevForm,
          fbPageAccount,
          fbPageList
        }
      })
      const filterSeat = seatData.filter((cat) => {
        return cat.accountId == accountValue;
      });
      console.log("filterSeat", filterSeat)
      console.log("accountValue", accountValue)
      if (filterSeat.length > 0) {
        filterSeat.map(data => {
          pageListFunction(data)
        })

      }

    }
  }, [seatData]);

  const getKeysByValues = (object, values) => {
    // console.log(object,values,'propsForDaypart')
    let keys = [];
    for (let prop in object) {
      if (object.hasOwnProperty(prop)) {
        if (values.includes(object[prop].toString()))
          keys.push(prop);
      }
    }
    return keys;
  }

  useEffect(() => {
    const audienceDataEdit = props.rowData.targeting && props.rowData.targeting.audience ? props.rowData.targeting.audience : [];
    const newSelectedAudienceState = { ...selectedAudienceState };
    if (audienceDataEdit && responseBySearchTerm && Object.keys(responseBySearchTerm).length > 0) {

      console.log("audienceDataEdit", audienceDataEdit, responseBySearchTerm)
      audienceDataEdit.forEach((item) => {
        const criterionId = item[props.platformType];
        const type = item.type;
        const matchingOption = responseBySearchTerm && responseBySearchTerm[item.value] && responseBySearchTerm[item.value].find((option) => option.criterionId == criterionId && option.type == type);

        // if(criterionId == "24922591487"){
        //   console.log(matchingOption,'matchingOption')
        // }

        if (matchingOption) {

          const selectedTabAudience = responseBySearchTerm[item.value] || [];
          console.log("newSelectedAudienceState", newSelectedAudienceState)
          console.log("selectedTabAudience", selectedTabAudience)

          // Update the individual checkbox state
          newSelectedAudienceState[item.value] = {
            ...newSelectedAudienceState[item.value],
            [matchingOption.id]: true,
          };

          // Check if all individual checkboxes are checked
          const allChecked = selectedTabAudience.every((option) => newSelectedAudienceState[item.value] && newSelectedAudienceState[item.value][option.id]);
          console.log("allChecked", allChecked)
          // Update the 'selectAll' checkbox state
          newSelectedAudienceState[item.value] = {
            ...newSelectedAudienceState[item.value],
            selectAll: allChecked,
          };


        }
      });
    }
    console.log(newSelectedAudienceState, 'newSelectedAudienceState')

    setSelectedAudienceState(newSelectedAudienceState);

  }, [responseBySearchTerm])


  useEffect(() => {
    if (languageData.length > 0 && props.rowData.targeting && props.rowData.targeting.language) {
      console.log("props.platformType", props.platformType)
      let language = findLanguageValue(props.rowData.targeting.language[props.platformType]);
      setForm((prevForm) => {
        return {
          ...prevForm,
          language
        }
      })
    }
  }, [languageData])


  // useEffect(() => {
  //   if (props.rowData.targeting.pageId && seatData.length > 0) {
  //     const accountValue = props.rowData.targeting.pageId;
  //     const filterSeat = seatData.filter((cat) => {
  //       return cat.accountId == accountValue;
  //     });
  //     console.log("seatData", seatData)
  //     console.log("filterSeat", filterSeat)
  //     console.log("accountValue", accountValue)
  //     if (filterSeat.length > 0) {
  //       filterSeat.map(data => {
  //         pageListFunction(data)
  //       })
  //     }
  //   }
  // }, [seatData])

  console.log("form", form)

  const initializeListApiCall = async () => {
    await thirdPartyAccount();
    await dataConfigApiFunction();
    // await dataConfigApiFunction();
    // await dataConfigV2ApiFunction();
    await languageApiFunction();
    // await locationApiFunction();

  };

  // Function to initialize age options
  useEffect(() => {
    const ageValues = Array.from(new Set(ageRangeData.map(item => parseInt(item.name.split('-')[0])))).sort((a, b) => a - b);
    const ageFromOptions = ageValues.map(value => ({ id: `${value}`, name: `${value}` }));
    setAgeFromOptions(ageFromOptions);
    console.log('Initialized ageFromOptions:', ageFromOptions);
  }, []);

  useEffect(() => {
    if (selectedAgeFrom !== null) {
      console.log('Selected Age From:', selectedAgeFrom);
      console.log('ageRangeData', ageRangeData);

      const matchingItems = ageRangeData.filter(item => item.name.startsWith(`${selectedAgeFrom}-`));

      console.log('Matching Items:', matchingItems);

      const ageToOptions = matchingItems.map(item => ({ id: `${item.name.split('-')[1]}`, name: `${item.name.split('-')[1]}` }));
      setAgeToOptions(ageToOptions);

      console.log('Updated ageToOptions:', ageToOptions);
    }
  }, [selectedAgeFrom, ageRangeData]);


  const dataConfigApiFunction = async () => {
    await dispatch(getDataConfigAction({ tenantId, authToken, userId }))
      .then((data) => {
        const {
          responseCode: { status = "" },
          response,
        } = data;

        if (status === "Success") {

          console.log("data", data)

          const findPlatform = platformData.find((data) => data.value.toLowerCase().includes(props.platformType.toLowerCase()));

          const pacingResponse = response.filter(item =>
            item.name == "Pacing_Type"
          );

          const biddingStrategy = response.filter(item =>
            item.name == "Bidding_Strategy"
          );

          const deviceResponse = response.filter(item =>
            item.name == "Device_Type"
          );

          const durationResponse = response.filter(item =>
            item.name == "Duration_Type"
          );

          const ageResponse = response.filter(item =>
            item.name == "Age_Type"
          );

          // setAgeRangeData(ageResponse[0].list)

          console.log("ageResponse", ageResponse)

          const genderResponse = response.filter(item =>
            item.name == "Gender_Type"
          );


          if (genderResponse) {
            if (findPlatform) {
              const findGenderDataForPlatform = genderResponse.find((dataPac) => dataPac.platformId == findPlatform.key);
              if (findGenderDataForPlatform) {
                setGenderData(findGenderDataForPlatform.list)
              }
            }
          }


          if (pacingResponse) {
            if (findPlatform) {
              const findPacingDataForPlatform = pacingResponse.find((dataPac) => dataPac.platformId == findPlatform.key);
              if (findPacingDataForPlatform) {
                setPacingData(findPacingDataForPlatform.list)
              }
            }
          }

          if (biddingStrategy) {
            if (findPlatform) {
              const findBiddingStratForPlatform = biddingStrategy.find((dataBid) => dataBid.platformId == findPlatform.key);
              console.log("findBiddingStratForPlatform",findBiddingStratForPlatform)
              if (findBiddingStratForPlatform) {
                setBiddingStrategyData(findBiddingStratForPlatform.list)
              }
            }
          }
          if (deviceResponse) {
            if (findPlatform) {
              const findDeviceForPlatform = deviceResponse.find((dataDev) => dataDev.platformId == findPlatform.key);
              if (findDeviceForPlatform) {
                const listDevice = findDeviceForPlatform.list.map((data) => {
                  return {
                    ...data,
                    label: data.name,
                    value: data.name
                  }
                })
                setDeviceData(listDevice)
              }
            }
          }

          if (durationResponse) {
            if (findPlatform) {
              const findDurationForPlatform = durationResponse.find((dataDur) => dataDur.platformId == findPlatform.key);
              if (findDurationForPlatform) {
                setDurationData(findDurationForPlatform.list)
              }
            }
          }

          // const durationTypeResponse = dataConfigAll.response.filter(item =>
          //   item.name == "Duration-Type"
          // );
          // if (durationTypeResponse) {
          //   setDurationData(durationTypeResponse[0].list);
          // }



          // if (deviceResponse.length > 0) {
          //   const deviceList = deviceResponse[0].list.map((item, index) => {
          //     return { label: item.name, value: item.id };
          //   });
          //   setDeviceData(deviceList);
          // }

          if (ageResponse && (props.platformType == "ads" || props.platformType == "dv360")) {

            if (ageResponse) {
              if (findPlatform) {
                const findAgeForPlatform = ageResponse.find((dataDur) => dataDur.platformId == findPlatform.key);
                if (findAgeForPlatform) {
                  setAgeRangeData(findAgeForPlatform.list);
                  console.log("findAgeForPlatform", findAgeForPlatform)
                  console.log("ageRangeData", ageRangeData)

                }
              }
            }
          }


          if (ageResponse && props.platformType != "ads" && props.platformType != "dv360" && props.platformType != "ion" && props.platformType != "viads") {
            if (findPlatform) {
              const findAgeForPlatform = ageResponse.find((dataDur) => dataDur.platformId == findPlatform.key);
              if (findAgeForPlatform) {
                setAgeRangeData(findAgeForPlatform.list)
              }
              // Extract unique age values and sort them
              const ageValues = Array.from(new Set(findAgeForPlatform.list.map(item => parseInt(item.name.split('-')[0])))).sort((a, b) => a - b);

              // Create options for ageFrom
              const ageFromOptions = ageValues.map(value => ({ id: `${value}`, name: `${value}` }));
              setAgeFromOptions(ageFromOptions);
              // console.log("findAgeForPlatform",findAgeForPlatform)
              // console.log("ageRangeData",ageRangeData)
              // console.log("ageValues",ageValues)
            }

          }
          getOnScreenPositionDetails(data);
        } else {
          console.log("List data not found");
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const dataConfigV2ApiFunction = async () => {

    const findPlatform = platformData || [].find((data) => data.value.toLowerCase().includes(props.platformType.toLowerCase()));

    console.log("findPlatform", findPlatform)

    if (findPlatform) {
      const payload = {
        platform: [findPlatform.key],
        type: "Onscreen_Type"
      };

      await dispatch(dataConfigV2Action({ tenantId, authToken, userId, payload }))
        .then((data) => {
          console.log("data", data)
          const {
            responseCode: { status = "" },
            response,
          } = data;

          if (status == "Success") {

            setOnScreenData(response);
          } else {
            console.log("List data not found");
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  const handleTouch = (e) => {
    const { name, value } = e.target;
    const { error } = handleFieldError(value, formFields[name]);
    setErrors({ ...errors, [name]: error });
    setTouched({ ...touched, [name]: true });
  };


  const calculateFrequencyCapTime = (perInterval) => {
    console.log("perInterval", perInterval);
    let value = '';
    if (perInterval == 0) {
      console.log('hello,*****************')
      formFields.frequencyCapTime.min = 1;
      formFields.frequencyCapTime.max = 23;

    }
    if (perInterval == 1) {
      console.log('hello,*****************')
      formFields.frequencyCapTime.min = 1;
      formFields.frequencyCapTime.max = 6;

    }
    if (perInterval == 2) {
      console.log('hello,*****************')
      formFields.frequencyCapTime.min = 1;
      formFields.frequencyCapTime.max = 4;

    }
    if (perInterval == 3) {
      console.log('hello,*****************')
      formFields.frequencyCapTime.min = 1;
      formFields.frequencyCapTime.max = 2;

    }
    if (perInterval == 4) {
      value = 1;

      console.log('hello,*****************')
      formFields.frequencyCapTime.min = 1;
      formFields.frequencyCapTime.max = 1;


    }
    return value;
  };

  const handleChange = (e) => {
    const { value, name, min } = e.target;
    console.log("value", value)
    console.log("name", name)



    if (name == "frequencyCapPerInterval") {
      let dataFreqTime = value;
      if (props.platformType == "dv360") {
        dataFreqTime = calculateFrequencyCapTime(value);
      }
      setForm((prev) => { return { ...prev, frequencyCapTime: dataFreqTime } });
    }



    if (name == "onScreenFb") {
      if (value.toLowerCase() == "manual") {
        setShowFbOptions(true);
      } else {
        setShowFbOptions(false);
      }
    }
    if (name == "ageFrom") {
      setSelectedAgeFrom(value);
    }

    if (name == "sDate") {
      if (value > form.eDate) {
        setForm((prev) => { return { ...prev, eDate: '' } });
      }
    }
    if (name == "eDate") {
      if (value < form.sDate) {
        setForm((prev) => { return { ...prev, sDate: '' } });
      }
    }

    const accountValue = e.target.value;
    const filterSeat = seatData.filter((cat) => {
      return cat.accountId == accountValue;
    });
    console.log("filterSeat", filterSeat)
    console.log("accountValue", accountValue)
    if (filterSeat.length > 0) {
      filterSeat.map(data => {
        pageListFunction(data)
      })
    }
    setForm((prev) => { return { ...prev, [name]: value } });
  };

  const thirdPartyAccount = async () => {
    console.log("here");

    try {
      const data = await dispatch(getThirdPartyAccountAction({ tenantId, authToken, userId }));

      const {
        responseCode: { status = "" },
        responseObj,
      } = data;
      console.log("data", data)


      if (status === "Success") {
        let seatData = [];
        console.log("responseObj", responseObj)

        if (responseObj) {
          // Check platformType and set seatData accordingly
          switch (props.platformType) {
            case 'ads':
              seatData = responseObj.googleadwords || [];
              break;
            case 'meta':
              seatData = responseObj.meta || [];
              break;
            case 'dv360':
              seatData = responseObj.dv360 || [];
              break;
            case 'tiktok':
              seatData = responseObj.tiktok || [];
              break;
            default:
              console.error(`Unhandled platformType: ${props.platformType}`);
          }
        } else {
          console.error("responseObj not found in API response");
        }

        setSeatData(seatData);
      } else {
        console.log("List data not found");
      }
    } catch (error) {
      console.error(error);
    }
  };


  const pageListFunction = async (data) => {

    const payload = {
      BekiAccountId: data.BekiAccountId,
      accountId: data.accountId
    }

    await dispatch(pageListAction({ tenantId, authToken, userId, payload })).then((data) => {
      // console.log("new a", cateID);
      // console.log("data", data)
      const {
        responseCode: { status = "" },
        response,
      } = data;

      if (status == "Success") {
        console.log("response", response)
        // const subCategoryListDropdownData = responseList.map((item, index) => {
        //   return { text: item.value, categoryID: item.id };
        // });
        setFbPageData(response);
      } else {
        console.log("List data not found");
      }
    })
      .catch((error) => {
        console.error(error);
      });
  }

  const languageApiFunction = async () => {
    const params = {
      platform: props.platformType,
    };
    // const mappingKeys = {
    //   'ads': adwords,
    //   'meta': meta,
    //   'tiktok': tiktok,
    //   // 'ion': ion,
    //   'dv360': dv360
    // };
    // const platformKey = mappingKeys[props.platformType];
    await dispatch(getLanguageAction({ tenantId, authToken, userId, params }))
      .then((data) => {
        console.log("data", data)
        const {
          responseCode: { status = "" },
          response,
        } = data;


        //   if (status == "Success") {
        //     const languageListDropdownData = responseList.map((item, index) => {
        //         return { text: item.languageConstant.name, id: item.languageConstant.resourceName };
        //     });

        //     // Find the default language, in this case, "English"
        //     const defaultLanguage = languageListDropdownData.find(language => language.text === "English");

        //     // Set the default language in the form object
        //     form.language = defaultLanguage ? defaultLanguage.id : '';

        //     this.setState({ languageData: languageListDropdownData });
        // }

        if (status === "Success") {
          setLanguageData(response);

        } else {
          console.log("List data not found");
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const handleAddFormClick = (formKey, setShowForm) => {
    setShowForm((prevShowForm) => !prevShowForm);
  };

  const handleRemoveOption = (removedOption, formKey) => {
    // Handle the removal of the option based on the form key
    if (formKey === "location") {
      setSelectedLocation((prevSelected) =>
        prevSelected.filter((option) => option.value !== removedOption.value)
      );
    } else if (formKey === "audience") {
      setSelectedAudience((prevSelected) =>
        prevSelected.filter((option) => option.value !== removedOption.value)
      );
    } else if (formKey === "keywords") {
      setSelectedKeywords((prevSelected) =>
        prevSelected.filter((option) => option.value !== removedOption.value)
      );
    }
    // Add more conditions for other form keys if needed
  };


  const handleSelectAllChange = (checked) => {
    const newSelectedAudienceState = { ...selectedAudienceState };
    const selectedTabAudience = responseBySearchTerm[selectedTab] || [];

    selectedTabAudience.forEach((option) => {
      newSelectedAudienceState[selectedTab] = {
        ...newSelectedAudienceState[selectedTab],
        [option.id]: checked,
      };
    });

    // Set the 'selectAll' property for the selected tab
    newSelectedAudienceState[selectedTab] = {
      ...newSelectedAudienceState[selectedTab],
      selectAll: checked,
    };

    setSelectedAudienceState(newSelectedAudienceState);
  };


  const renderAudienceColumns = () => {
    const mappingKeys = {
      'ads': adwords,
      'meta': meta,
      'tiktok': tiktok,
      'ion': IONLogo,
      'viads': ViLogo,
      'dv360': dv360
    };

    const titleKeys = {
      'ads': 'Google Ad',
      'meta': 'Meta',
      'tiktok': 'TikTok',
      'ion': 'ION',
      'viads': 'ViAds',
      'dv360': 'DV360'
    };

    const audienceTypeKeys = {
      0: 'Inmarket',
      1: 'Affinity',
      2: 'IAB',
      3: 'Geo',
      4: 'Demographic',
      5: 'Affinity',
      6: 'Behaviour',
      7: 'Interest',
      8: 'Interest',
      9: 'Behaviour',
      10: 'Demographic',
      11: 'Demographic',
      12: 'Demographic',
      13: 'Demographic',
      14: 'Demographic',
      15: 'Demographic',
      16: 'Demographic',
      17: 'Demographic',
      18: 'Demographic',
      19: 'Demographic',
      20: 'Demographic',
      21:'VIL Digital',
      22:'SMS'
    };
    //audienceTypeKeys provided by backend team

    const platformKey = mappingKeys[props.platformType];
    const titleKey = titleKeys[props.platformType];
    console.log("audData", audData)
    console.log("listAudienceData", listAudienceData)
    console.log("responseBySearchTerm", responseBySearchTerm)
    if (audData.length > 0 && selectedTab) {
      return (
        <>
          <Tabs activeKey={selectedTab} onChange={(key) => setSelectedTab(key)} tabBarStyle={{ borderBottom: 'none' }}>
            {audData.map((tab) => (
              <TabPane tab={<span style={{ textTransform: 'capitalize' }}>{tab}</span>} key={tab}>
                {/* Render content for each tab */}
                {responseBySearchTerm[tab] && responseBySearchTerm[tab].length > 0 ? (
                  <table className="audience-table w-50 mt-n3">
                    <thead>
                      <tr>
                        <th></th>
                        <th>
                          {/* <img src={platformKey} alt={platformKey} />
                        <div className='checkbox-title'>{titleKey}</div> */}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td style={{ color: "#707B8A", fontSize: 14, lineHeight: "16.8px", fontWeight: 500 }}>Audience Type</td>
                        <td style={{ color: "#394256", fontSize: 12, lineHeight: "16.8px", fontWeight: 500 }}>
                          <Checkbox
                            checked={selectedAudienceState[selectedTab] && selectedAudienceState[selectedTab].selectAll}
                            onChange={(e) => handleSelectAllChange(e.target.checked)}
                            style={{ verticalAlign: "middle", marginRight: 5 }}
                          />
                          Select All
                        </td>
                      </tr>
                      {/* {listAudienceData.map((option) => ( */}
                      {responseBySearchTerm[selectedTab] && responseBySearchTerm[selectedTab].length > 0 && responseBySearchTerm[selectedTab].map((option) => (
                        <tr key={option.id} className="audience-data">
                          <td>
                            <i className="ti ti-info-circle" style={{ fontSize: 15 }} title={option.canonicalPath}></i>
                            {option.name}
                          </td>
                          <td>
                            <Checkbox
                              checked={selectedAudienceState[selectedTab] && selectedAudienceState[selectedTab][option.id]}
                              onChange={(e) => handleCheckboxChange(option.id, e.target.checked)}
                            />{' '}&nbsp;
                            {audienceTypeKeys[option.type]}
                            {/* Render data for Google AdWords */}
                          </td>

                          {/* Add more columns as needed */}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <div className="text-center pb-4">
                    <h4>No Audience Available</h4>
                  </div>
                )}
              </TabPane>
            ))}
          </Tabs>
        </>
      );

    }
    return null;
  };

  const locationApiFunction = async (searchTerm) => {
    if (searchTerm.trim() == "") {
      // If searchTerm is empty or contains only whitespaces, do not make the API call
      return;
    }
    const mappingKeys = {
      'ads': 'google',
      'meta': 'meta',
      'tiktok': 'tiktok',
      'ion': 'ion',
      'dv360': 'google',
      'viads':'viads'
    };

    const platformKey = mappingKeys[props.platformType];

    let params = {
      location: searchTerm,
      // platform: "beki"
      platform: platformKey
    }

    await dispatch(getLocationAction({ tenantId, authToken, userId, params }))
      .then((data) => {
        const {
          responseCode: { status = "" },
          responseObj,
        } = data;

        console.log("responseObj", responseObj)

        if (status === "Success") {
          const mappedOptions = responseObj.map((location) => ({
            ...location,
            value: location.criterionId,
            label: location.name,
          }));
          console.log("mappedoptions", mappedOptions)

          setLocationData(mappedOptions);
        } else {
          console.log("List data not found");
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const audienceApiFunction = async (searchTerm) => {
    console.log("searchTerm", searchTerm)
    if (searchTerm.trim() == "") {
      // If searchTerm is empty or contains only whitespaces, do not make the API call
      return;
    }

    const mappingKeys = {
      'ads': 4,
      'meta': 3,
      'tiktok': 7,
      'ion': 2,
      'dv360': 4,
      'viads':8
    };

    const platformKey = mappingKeys[props.platformType];

    let params = {
      audience: searchTerm,
      // platform: "beki"
      platformId: platformKey,
      type: props.rowData.type == 2 ? '' : '0'
    }

    await dispatch(getAudienceAction({ tenantId, authToken, userId, params }))
      .then((data) => {
        const {
          responseCode: { status = "" },
          responseObj,
        } = data;


        if (status === "Success") {
          // const mappedOptions = response.map((location) => ({
          //   value: location.id,
          //   label: location.name,
          // }));
          console.log("response894", responseObj)

          setListAudience(responseObj);
          setResponseBySearchTerm((prevResponse) => ({
            ...prevResponse,
            [searchTerm]: responseObj,
          }));
        } else {
          console.log("List data not found");
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const backtoList = () => {
    props.setStrategy();
    props.setComponentVisibility(false);
    props.setShowStepper(true);
  }

  const addStrategy = async () => {

    let mainError = {};
    let validStrategy = true;
    let validFreq = true;
    let { errors, valid } = handleError(form, formFields);

    mainError = { ...mainError, ...errors }

    if (!valid) {
      validStrategy = false;
    }

    console.log("form", form)
    if (props.platformType != "ads" && props.platformType != "meta" && props.platformType!="ion" && props.platformType!="viads" && selectedOptionFrequency == "limited") {
      if (form.frequencyCapTime && form.frequencyCapTo && form.frequencyCapPerInterval) {
        validFreq = true;
      }
      else {
        validFreq = false;
      }
    }

    if ((props.platformType=="ion" || props.platformType=="viads") && selectedOptionFrequency == "limited") {
      if (form.hasOwnProperty("frequencyCapTo") && form.frequencyCapTo.toString().length > 0 && form.frequencyCapPerInterval) {
        validFreq = true;
      }
      else {
        validFreq = false;
      }
    }

    if (props.platformType == "ads" || props.platformType == "dv360") {
      const { errors, valid } = handleError(form, formFeildAge);
      if (!valid) {
        mainError = { ...mainError, ...errors }
        validStrategy = false;
      }
    }

    if (props.platformType == "meta") {
      const { errors, valid } = handleError(form, formFeildsAgeFromTo);
      if (!valid) {
        mainError = { ...mainError, ...errors }
        validStrategy = false;
      }
      const { errors: errorsDayPart, valid: validDaypart } = handleError(form, formFeildfacebookPageList);
      if (!validDaypart) {
        validStrategy = false;
        message.error('Please select page for meta');
      }
      else if (locationPayload.length == 0) {
        validStrategy = false;
        message.error('Please select location for meta');
      }
    }

    if (!validStrategy) {
      setErrors(mainError);
      setSubmited(true);
    }

    else if (!validFreq) {
      message.error("Please Fill Frequency Capping Values")
    }

    else {


      // AGE for others

      let matchingAgeObj = {}
      if (props.platformType != "ads" && props.platformType != "dv360") {
        matchingAgeObj = ageRangeData.find(item => item.name == `${form.ageFrom + '-' + form.ageTo}`);
        console.log("matchingAgeObj", matchingAgeObj)

      }
      const campaignIdCreated = sessionStorage.getItem('campaignIdCreated');

      const formattedDayparts = dayparts.map((daypart) => {


        const selectedDays = daypart.selectedDays
          .map((day) => dayOfWeekMap[day])
          .join(',');

        const time = `${daypart.startTime.toString().replace(":", '.')},${daypart.endTime.toString().replace(":", '.')}`;

        return {
          day: selectedDays,
          time,
          startDate: daypart.startDate && moment(daypart.startDate).format('YYYY-MM-DD') ? moment(daypart.startDate).format('YYYY-MM-DD') : '',
          endDate: daypart.endDate && moment(daypart.endDate).format('YYYY-MM-DD') ? moment(daypart.endDate).format('YYYY-MM-DD') : '',
        };
      });
      console.log("formattedDayparts", formattedDayparts)
      let payloadLanguage = null

      if (form.language && languageData.length > 0) {
        // Find the languageData entry based on form.language
        const selectedLanguage = languageData.find((language) => language.id === form.language.toString());
        // console.log("selectedLanguage", selectedLanguage)

        if (selectedLanguage) {
          // Specify the mapping keys for different platform types
          const mappingKeys = {
            'ads': 'adwordsId',
            'dv360': 'adwordsId',
            'meta': 'metaId',
            'tiktok': 'tiktokId',
            'ion': 'ionId',
            // Add more mappings as needed
          };

          // Get the mapping key based on the platformType
          const platformKey = mappingKeys[props.platformType];
          console.log("selectedLanguage[platformKey]", selectedLanguage[platformKey],)
          // Create the payload format
          payloadLanguage = {
            [props.platformType]: selectedLanguage[platformKey],
            value: selectedLanguage.value,
            inex: 1, // You need to specify the correct value for this property
          };
        }
      }


    const audiencePayload = [];

      Object.keys(selectedAudienceState).forEach((tab) => {
        const selectedTabAudience = responseBySearchTerm[tab] || []; // Selected audience tabs

        console.log("selectedTabAudience", selectedTabAudience)
        console.log("selectedAudienceState", selectedAudienceState)

        const type = props.platformType;
        selectedTabAudience.forEach((option, index) => {
          if (selectedAudienceState[tab] && selectedAudienceState[tab][option.id]) {
            audiencePayload.push({
              [type]: option.criterionId, // props.platformType
              // value: option.name,
              value: tab, // Tabs are value that is searched
              type: parseInt(option.type),
              adType: parseInt(option.adType),
              inex: 1,
            });
          }
        });
      });

      console.log("audiencePayload", audiencePayload)
      console.log("selectedDevices", selectedDevices)

      const devicePayload = selectedDevices.map((item) => ({
        key: item.id,
        value: item.value,
      }));


      const genderPayload = genderData
        .filter(({ id }) => String(id) === String(form.gender))
        .map(({ id, name }) => ({
          key: id,
          value: name
        }));

      console.log(props, 'PROPS');
      // Create a Set to keep track of unique ads values
      const uniqueAdsValues = new Set();

      // Use the filter method to create a new array without duplicates
      console.log("locationPayload", locationPayload)
      const uniqueLocationData = locationPayload.filter(item => {
        // Check if the ads value is already in the Set
        if (uniqueAdsValues.has(item[props.platformType])) {
          return false; // Skip duplicates
        }

        // Add the ads value to the Set and include the item in the new array
        uniqueAdsValues.add(item[props.platformType]);
        return true;
      });

      console.log("12345", uniqueLocationData);

      if (props.screenType == "add") {


        const mappingKeys = {
          'ads': 4,
          'meta': 3,
          'tiktok': 7,
          'ion': 2,
          'dv360': 5,
          'viads':8
        };

        const platformId = mappingKeys[props.platformType];

        let addNewStrategy = {
          "campaignId": props.rowData.id,
          "strategyName": form.strategyName,
          "budget": parseFloat(form.budget),
          "sDate": moment(form.sDate).format('YYYY-MM-DD'),
          "eDate": moment(form.eDate).format('YYYY-MM-DD'),
          "pacingType": parseInt(form.pacing),
          "duration": parseInt(form.duration),
          "platformId": parseInt(platformId),
          "mediaType": parseInt(props.rowData.type)
        }
        console.log("addNewStrategy", addNewStrategy)

      await dispatch(postAddNewStrategyAction({ tenantId, authToken, userId, alreadyMadeStrategy: addNewStrategy })).then((data) => {
        const {
          responseCode: { status = "", msg },
          responseObj,
        } = data;
        console.log("data", data)

        if (status == "Success") {
          // debugger;
          let newStrategy = {
            id: responseObj,
            type: parseInt(props.rowData.type),
            name: form.strategyName,
            budget: parseFloat(form.budget),
            sDate: moment(form.sDate).format('YYYY-MM-DD'),
            eDate: moment(form.eDate).format('YYYY-MM-DD'),
            "campaignId": props.rowData.id,
            "pacingType": parseInt(form.pacing),
            "duration": parseInt(form.duration),
            "status": 1,
            "bidStrategy": parseInt(form.biddingStrategy),
            // "bidCap": 3.9,
            ...(selectedOptionFrequency === "limited" ? {
              "freqCap": {
                "cap": parseInt(form.frequencyCapTo),
                "time": parseInt(form.frequencyCapTime),
                "interval": parseInt(form.frequencyCapPerInterval),
                "level": 1
              }
            } : {}),
            "targeting": {
              "location": uniqueLocationData.length > 0 ? uniqueLocationData : null,
              "audience": audiencePayload.length > 0 ? audiencePayload : null,
              "age": matchingAgeObj ? (matchingAgeObj.hasOwnProperty("id") ? parseInt(matchingAgeObj.id) : parseInt(form.ageGoogleAds)):null,
              "device": devicePayload.length > 0 ? devicePayload : null,
              "gender": genderPayload.length > 0 ? genderPayload : null,
              "daypart": selectedOption === "customSchedules" ? (formattedDayparts.length > 0 ? formattedDayparts : []) : [],
              "keywords": {
                "values": keywordsData.map(keyword => (keyword)),
                "index": "1"
              },
              "sites": {
                "values": sitesData.map(site => (site)),
                "inex": selectedOptionSites == "whiteList" ? 1 : 0
              },
              "language": payloadLanguage,
              "pageId": form.fbPageList ? form.fbPageList : '',
              "position": onScreenData && onScreenData.length > 0 ? onScreenData.map(item => ({ key: item.id, value: item.name })) : []
            }
          }

            let modifiedTableData = props.tableData;
            modifiedTableData[props.platformType] = modifiedTableData[props.platformType].map(item => {
              if (item.id == props.rowData.id) {
                item.stratgies = [...item.stratgies, newStrategy];
              }
              return item;
            });
            let modifiedTableDataWithBudget = cloneDeep(modifiedTableData);
            const parentEntryIndex = modifiedTableDataWithBudget[props.platformType].findIndex(entry => entry.id === props.rowData.id);

            if (parentEntryIndex !== -1) { // Ensure parent entry is found
              const parentEntry = modifiedTableDataWithBudget[props.platformType][parentEntryIndex];
              const totalStrategiesBudget = parentEntry.stratgies.reduce((sum, strategy) => sum + strategy.budget, 0);

              const updatedCampaignEntry = {
                ...parentEntry,
                budget: totalStrategiesBudget,
              };

              // Update modifiedTableData with the updated campaign entry
              modifiedTableDataWithBudget[props.platformType][parentEntryIndex] = updatedCampaignEntry;
            }

            console.log("999 modifiedTableData", modifiedTableDataWithBudget)
            // localStorage.setItem('strategyListData', JSON.stringify(modifiedTableData));
            dispatch(strategyListReduxAction({
              strategyData: modifiedTableDataWithBudget
            }));
            props.setTableData(modifiedTableDataWithBudget);
            props.setComponentVisibility(false);
            props.setShowStepper(true);
            console.log("modifiedTableData", modifiedTableDataWithBudget)

            message.success(msg)
          }
          else if (status == "Fail") {
            message.error(msg)
          }
          else {
            console.log("Data not found");
          }
        })
          .catch((error) => {
            console.error(error);
          });

      } 
     else if (props.screenType == "edit") {


      let clonedForm = cloneDeep(form);
      let clonedProps = cloneDeep(props);

      console.log("edit", props.screenType)
      let newEditStrategy = {
        id: clonedProps.rowData.id,
        type: parseInt(clonedProps.rowData.type),
        name: clonedForm.strategyName,
        budget: parseFloat(clonedForm.budget),
        sDate: moment(clonedForm.sDate).format('YYYY-MM-DD'),
        eDate: moment(clonedForm.eDate).format('YYYY-MM-DD'),
        "campaignId": clonedProps.rowData.campaignId,
        "pacingType": parseInt(clonedForm.pacing),
        "duration": parseInt(form.duration),
        "status": 1,
        "bidStrategy": parseInt(clonedForm.biddingStrategy),
        // "bidCap": 3.9,
        ...(selectedOptionFrequency === "limited" ? {
          "freqCap": {
            "cap": parseInt(clonedForm.frequencyCapTo),
            "time": parseInt(clonedForm.frequencyCapTime),
            "interval": parseInt(clonedForm.frequencyCapPerInterval),
            "level": 1
          }
        } : {}),
        "targeting": {
          "location": uniqueLocationData.length > 0 ? uniqueLocationData : null,
          "audience": audiencePayload.length > 0 ? audiencePayload : null,
          "age": matchingAgeObj ? (matchingAgeObj.hasOwnProperty("id") ? parseInt(matchingAgeObj.id) : parseInt(form.ageGoogleAds)):null,
          "device": devicePayload.length > 0 ? devicePayload : null,
          "gender": genderPayload.length > 0 ? genderPayload : null,
          "daypart": selectedOption === "customSchedules" ? (formattedDayparts.length > 0 ? formattedDayparts : []) : [],
          "keywords": {
            "values": keywordsData.map(keyword => (keyword)),
            "index": "1"
          },
          "sites": {
            "values": sitesData.map(site => (site)),
            "inex": selectedOptionSites == "whiteList" ? 1 : 0
          },
          "language": payloadLanguage,
          "pageId": form.fbPageList ? form.fbPageList : '',
          "position": onScreenData && onScreenData.length > 0 ? onScreenData.map(item => ({ key: item.id, value: item.name })) : []
        }
      };

        console.log("newEditStrategy", newEditStrategy)


        let modifiedTableData = props.tableData;

        modifiedTableData[props.platformType] = modifiedTableData[props.platformType].map(item => {
          let updatedStrategies = item.stratgies.map(strategy => {
            if (strategy.id == props.rowData.id)
              strategy = newEditStrategy;
            return strategy;
          });
          item.stratgies = updatedStrategies;
          return item;
        });

        let modifiedTableDataWithBudget = cloneDeep(modifiedTableData);


        const parentEntryIndex = modifiedTableDataWithBudget[props.platformType].findIndex(entry => entry.id === props.rowData.campaignId);

        if (parentEntryIndex !== -1) { // Ensure parent entry is found
          const parentEntry = modifiedTableDataWithBudget[props.platformType][parentEntryIndex];
          const totalStrategiesBudget = parentEntry.stratgies.reduce((sum, strategy) => sum + strategy.budget, 0);

          const updatedCampaignEntry = {
            ...parentEntry,
            budget: totalStrategiesBudget,
          };

          // Update modifiedTableData with the updated campaign entry
          modifiedTableDataWithBudget[props.platformType][parentEntryIndex] = updatedCampaignEntry;
        }

        console.log("999 modifiedTableData", modifiedTableDataWithBudget)
        // localStorage.setItem('strategyListData', JSON.stringify(modifiedTableData));
        dispatch(strategyListReduxAction({
          strategyData: modifiedTableDataWithBudget
        }));
        props.setTableData(modifiedTableDataWithBudget);
        props.setComponentVisibility(false);
        props.setShowStepper(true);

        message.success("Strategy Updated")


      } else {
        console.log('edit case');
      }

      // console.log("payloadStrategyNext", payloadStrategyNext)

      // await dispatch(postBasicDetailsSubmitAction({ tenantId, authToken, userId, payload })).then((data) => {
      //   const {
      //     responseCode: { status = "", msg },
      //     responseObj,
      //   } = data;
      //   console.log("data", data)

      //   if (status === "Success") {
      //     // setBasicDetalsSubmit(response);
      //     // setCampaignId(responseObj);
      //     message.success(msg)
      //     // next();
      //   }
      //   else if (status == "Fail") {
      //     // toast(status, msg)
      //   }
      //   else {
      //     console.log("Data not found");
      //   }
      // })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    }
  };


  const handleKeyDown = async (e) => {
    const { key } = e;
    const { name, value } = e.target;
    if (name == formFields.audience.key) {
      if (key.toLowerCase() == "enter" && value.trim().length > 0) {
        if (!audData.includes(value)) {
          let dataAudienceCloned = cloneDeep(audData);
          dataAudienceCloned.push(value);
          audienceApiFunction(value)
          setaudData(dataAudienceCloned);
          setForm((prevForm) => ({ ...prevForm, [name]: '' }));
          setSelectedTab(value); // Set the selected tab to the newly added tag

        } else {
          // Value is already present, handle accordingly (e.g., show a message)
          console.log('Value already exists in audData:', value);
        }

      }
    }
    else if (name == formFields.keywords.key) {
      if (key.toLowerCase() == "enter" && value.trim().length > 0) {
        let dataKeywordsCloned = cloneDeep(keywordsData);
        dataKeywordsCloned.push(value);
        setKeywordsData(dataKeywordsCloned);
        setForm((prevForm) => ({ ...prevForm, [name]: "" }));
      }
    }
    else if (name == formFields.sites.key) {
      if (key.toLowerCase() == "enter" && value.trim().length > 0) {
        let dataSitesCloned = cloneDeep(sitesData);
        dataSitesCloned.push(value);
        setSitesData(dataSitesCloned);
        setForm((prevForm) => ({ ...prevForm, [name]: "" }));
      }
    }
  };


  const removeTag = (tag) => {
    // Remove the tag from audData
    let filteredTagList = audData.filter((dataTag) => dataTag !== tag);
    setaudData(filteredTagList);

    // Remove corresponding data from responseBySearchTerm
    let updatedResponseBySearchTerm = { ...responseBySearchTerm };
    delete updatedResponseBySearchTerm[tag];
    setResponseBySearchTerm(updatedResponseBySearchTerm);

    // Remove entries associated with the removed tag from selectedAudienceState
    const newSelectedAudienceState = { ...selectedAudienceState };

    Object.keys(newSelectedAudienceState).forEach((tab) => {
      if (tab === tag) {
        // Remove the tag (e.g., "art") from newSelectedAudienceState
        delete newSelectedAudienceState[tab];
      } else {
        // Remove the tag from individual checkboxes
        if (newSelectedAudienceState[tab]) {
          delete newSelectedAudienceState[tab][tag];

          // Check if 'selectAll' should be updated
          const selectedTabAudience = responseBySearchTerm[tab] || [];
          const allChecked = selectedTabAudience.every((option) => newSelectedAudienceState[tab] && newSelectedAudienceState[tab][option.id]);

          // Update the 'selectAll' checkbox state
          newSelectedAudienceState[tab] = {
            ...newSelectedAudienceState[tab],
            selectAll: allChecked,
          };
        }
      }
    });

    setSelectedAudienceState(newSelectedAudienceState);
  };


  const removeKeywordsTag = (tag) => {
    let filtedTagList = keywordsData.filter((dataTag) => dataTag != tag);
    setKeywordsData(filtedTagList);
  };


  const removeSitesTag = (tag) => {
    let filtedTagList = sitesData.filter((dataTag) => dataTag != tag);
    setSitesData(filtedTagList);
  };

  const ionViOnScreenData = useMemo(() => {
    let data = [];
    if (['ion', 'viads'].includes(props.platformType) && onScreenData && onScreenData.length > 0) {
      data = onScreenData.map(
        (data) => ({ label: data.name, value: data.id })
      );
    }
    return data;
  }, [onScreenData]);

  // console.log(ionViOnScreenData,'ionViOnScreenData',onScreenData)

  console.log("selectedAudienceState", selectedAudienceState)

  const renderNestedList = (list) => {
    if (!list || list.length === 0) {
      return null;
    }

    return (
      <div className="d-flex flex-column pl-5">
        {list.map((item) => (
          <div className='checkbox-group' key={item.id}>
            <div className='checkbox-item'>
              <input type="checkbox" id={`fb${item.name.replace(/\s+/g, '')}`} name={`fb${item.name.replace(/\s+/g, '')}`} />
              <label htmlFor={`fb${item.name.replace(/\s+/g, '')}`}>{item.name}</label>
            </div>
            {renderNestedList(item.list)}
          </div>
        ))}
      </div>
    );
  };

  const getStrategyString = (screenType, platformType, rowDataType) => {
    const screenTypes = {
      add: "New Strategy",
      copy: "Clone Strategy",
      edit: {
        ads: {
          2: "Google Adwords Search Strategy",
          0: "Google Adwords Display Strategy"
        },
        meta: {
          1: "Meta Video Strategy",
          0: "Meta Display Strategy"
        },
        dv360: {
          1: "DV360 Video Strategy",
          0: "DV360 Display Strategy"
        },
        ion: {
          1: "ION Video Strategy",
          0: "ION Display Strategy"
        },
        viads: {
          1: "ViAds Video Strategy",
          0: "ViAds Display Strategy"
        },
        tiktok: "Tiktok Strategy"
      }
    };

    if (screenTypes[screenType]) {
      if (typeof screenTypes[screenType] === 'string') {
        return screenTypes[screenType];
      } else if (screenTypes[screenType][platformType]) {
        if (typeof screenTypes[screenType][platformType] === 'string') {
          return screenTypes[screenType][platformType];
        } else if (screenTypes[screenType][platformType][rowDataType]) {
          return screenTypes[screenType][platformType][rowDataType];
        }
      }
    }
    return "";
  }

  return (
    <>
      {props.setShowStepper && (
        <div className="d-flex justify-content-between mb-3">
          <div
            onClick={() => backtoList()}
            style={{
              fontSize: 20,
              fontWeight: 500,
              lineHeight: "24px",
              color: "#000",
              cursor: "pointer", // Add cursor style to indicate it's clickable
            }}
          >
            <i className="ti ti-arrow-left mr-2"></i>
            {getStrategyString(props.screenType, props.platformType, props.rowData.type)}
          </div>
          <div>
            <Button style={{ margin: '0 8px' }} onClick={() => backtoList()}>
              Cancel
            </Button>
            <Button style={{ margin: '0 8px' }} onClick={() => addStrategy()}>
              Save
            </Button>
          </div>
        </div>
      )}


      <div className="row">
        <div className="col-md-6">
          <Input
            onChange={handleChange}
            onBlur={handleTouch}
            value={form[formFields.strategyName.key]}
            setting={formFields[formFields.strategyName.key]}
            error={errors[formFields.strategyName.key]}
            submited={submited}
            touched={touched[formFields.strategyName.key]}
          />
        </div>
        <div className="col-md-6 ">
          <SelectNew
            onChange={handleChange}
            onBlur={handleTouch}
            value={form[formFields.biddingStrategy.key]}
            setting={formFields[formFields.biddingStrategy.key]}
            error={errors[formFields.biddingStrategy.key]}
            submited={submited}
            touched={touched[formFields.biddingStrategy.key]}
            options={biddingStrategy}
          />
        </div>
        <div className="col-md-6 ">
          <SelectNew
            onChange={handleChange}
            onBlur={handleTouch}
            value={form[formFields.pacing.key]}
            setting={formFields[formFields.pacing.key]}
            error={errors[formFields.pacing.key]}
            submited={submited}
            touched={touched[formFields.pacing.key]}
            options={pacingData}
          />
        </div>
        <div className="col-md-6">
          <SelectNew
            onChange={handleChange}
            onBlur={handleTouch}
            value={form[formFields.duration.key]}
            setting={formFields[formFields.duration.key]}
            error={errors[formFields.duration.key]}
            submited={submited}
            touched={touched[formFields.duration.key]}
            // options={durationData}
            options={durationData}
          />
        </div>





        <div className="col-md-6">
          <Input
            onChange={handleChange}
            onBlur={handleTouch}
            value={form[formFields.budget.key]}
            setting={formFields[formFields.budget.key]}
            error={errors[formFields.budget.key]}
            submited={submited}
            touched={touched[formFields.budget.key]}
          />
        </div>

        <div className="row col-md-6 pr-0">
          <div className="col-md-6">
            <DatepickerD
              onChange={handleChange}
              onBlur={handleTouch}
              value={form[formFields.sDate.key] || ''}
              setting={formFields[formFields.sDate.key]}
              error={errors[formFields.sDate.key]}
              submited={submited}
              touched={touched[formFields.sDate.key]}
              // minDate={new Date()}
              // maxDate={form.end == '' ? new Date() : form.endDate}
              minDate={new Date()}
              maxDate={basicDetailsForm ? basicDetailsForm.endDate : ''}
              showDisabledMonthNavigation
              disabled={props.id ? true : false}
            />
          </div>
          <div className="col-md-6 pr-0 pl-3">
            <DatepickerD
              onChange={handleChange}
              onBlur={handleTouch}
              value={form[formFields.eDate.key] || ''}
              setting={formFields[formFields.eDate.key]}
              error={errors[formFields.eDate.key]}
              submited={submited}
              touched={touched[formFields.eDate.key]}
              isDisabled={form.startDate ? false : true}
              // minDate={props.id ? new Date() : form.startDate == '' ? new Date() : form.sDate}
              minDate={new Date()}
              maxDate={basicDetailsForm ? basicDetailsForm.endDate : ''}
              sDate={form.startDate ? form.startDate : form.sDate ? form.sDate : ""}
            />
          </div>
        </div>



        <div className="col-md-6 ">
          <div className="form-group row mb-1 ">
            <label for="device" class="col-12 col-form-label pb-0">
              Device  <span class="small" style={{ color: "#1925238a" }}>Optional</span>
            </label>
          </div>
          <Select
            // options={deviceData}
            options={deviceData}
            isMulti={true}
            placeholder="Select Device"
            defaultValue={selectedDevices}
            value={selectedDevices}
            onChange={(selected) => handleSelectChange(selected, "device")}
            className="campaignFilter my-2"
          />
          {/* const advsData = responseObj.advertiserId.map((item, index) => {
          return { label: item.value, value: item.key };
        }); */}
          {/* <SelectNew
            onChange={handleChange}
            onBlur={handleTouch}
            value={form[formFields.device.key]}
            setting={formFields[formFields.device.key]}
            error={errors[formFields.device.key]}
            submited={submited}
            touched={touched[formFields.device.key]}
            options={[
              {
                "id": 28,
                "name": "Desktop",
                "createdOn": "2023-12-01 15:55:04",
                "createdBy": 1,
                "modifiedBy": 0
              },
              {
                "id": 29,
                "name": "Tablet",
                "createdOn": "2023-12-01 15:55:04",
                "createdBy": 1,
                "modifiedBy": 0
              },
              {
                "id": 30,
                "name": "Mobile",
                "createdOn": "2023-12-01 15:55:04",
                "createdBy": 1,
                "modifiedBy": 0
              }
            ]}
          /> */}
        </div>

        {(props.platformType != "ads" && props.platformType != "dv360" && props.platformType != "ion" && props.platformType != "viads") &&
          <div className="col-md-6">
            <div className="form-group row ">
              <label for="agegroup" class="col-12 col-form-label">
                Age Group <span class="small" style={{ color: "#1925238a" }}>Optional</span>
                {/* <span class="text-danger">*</span> */}
              </label>
              <div className="col-md-6">
                <SelectNew
                  onChange={handleChange}
                  onBlur={handleTouch}
                  value={form[formFeildsAgeFromTo.ageFrom.key]}
                  setting={formFeildsAgeFromTo[formFeildsAgeFromTo.ageFrom.key]}
                  error={errors[formFeildsAgeFromTo.ageFrom.key]}
                  submited={submited}
                  touched={touched[formFeildsAgeFromTo.ageFrom.key]}
                  options={ageFromOptions}
                />
              </div>
              <div className="col-md-6">
                <SelectNew
                  onChange={handleChange}
                  onBlur={handleTouch}
                  value={form[formFeildsAgeFromTo.ageTo.key]}
                  setting={formFeildsAgeFromTo[formFeildsAgeFromTo.ageTo.key]}
                  error={errors[formFeildsAgeFromTo.ageTo.key]}
                  submited={submited}
                  touched={touched[formFeildsAgeFromTo.ageTo.key]}
                  options={ageToOptions}
                />
              </div>
            </div>
          </div>
        }


        {(props.platformType == "ads" || props.platformType == "dv360") &&
          <div className="col-md-6">
            <div className="form-group row ">
              <label for="agegroup" class="col-12 col-form-label">
                Age Group <span class="small" style={{ color: "#1925238a" }}>Optional</span>
                {/* <span class="text-danger">*</span> */}
              </label>
              <div className="col-md-12 ">
                <SelectNew
                  onChange={handleChange}
                  onBlur={handleTouch}
                  value={form[formFeildAge.ageGoogleAds.key]}
                  setting={formFeildAge[formFeildAge.ageGoogleAds.key]}
                  error={errors[formFeildAge.ageGoogleAds.key]}
                  submited={submited}
                  touched={touched[formFeildAge.ageGoogleAds.key]}
                  options={ageRangeData}
                />
              </div>
            </div>
          </div>
        }

{
(props.platformType != "ion" && props.platformType != "viads") &&
<div className="col-md-6 ">
          <SelectNew
            onChange={handleChange}
            onBlur={handleTouch}
            value={form[formFields.gender.key]}
            setting={formFields[formFields.gender.key]}
            error={errors[formFields.gender.key]}
            submited={submited}
            touched={touched[formFields.gender.key]}
            options={genderData}
          />
        </div>
}
        

        <div className="col-md-6 ">
          <SelectNew
            onChange={handleChange}
            onBlur={handleTouch}
            value={form[formFields.language.key]}
            setting={formFields[formFields.language.key]}
            error={errors[formFields.language.key]}
            submited={submited}
            touched={touched[formFields.language.key]}
            options={languageData}
          />
        </div>
      </div>


      <CSSTransition
        in={showFrequencyForm}
        timeout={300}
        classNames="form-transition"
        unmountOnExit
      >
        <div>
          <div class="col-md-12 px-0 pb-2" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>Frequency Management</label></div>

          <div className="col d-flex align-items-start flex-column pb-3 px-0">
            <div className="d-flex align-items-center pr-4">
              <input
                type="radio"
                id="none"
                name="Frequency"
                value="none"
                checked={selectedOptionFrequency === "none"}
                onChange={() => setSelectedOptionFrequency("none")}
              />
              <label htmlFor="none" className="mb-0 pl-2">
                None
              </label>
            </div>
            <div className="d-flex align-items-start pt-2">
              <input
                type="radio"
                id="limited"
                name="Frequency"
                value="limited"
                checked={selectedOptionFrequency === "limited"}
                onChange={() => setSelectedOptionFrequency("limited")}
                style={{ marginTop: 12 }}
              />
              <label htmlFor="limited" className="mb-0 pl-2 pt-2">
                Limit Frequency
              </label>

              {
                selectedOptionFrequency === "limited" && (

                <React.Fragment>
                <div className='d-flex justify-content-start align-items-start' >
                <div class="col-md-2 px-0 pl-1" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "13px" }}>To</label></div>
                <div class="col-md-10 pr-3">
                  <Input
                    onChange={handleChange}
                    onBlur={handleTouch}
                    value={form[formFields.frequencyCapTo.key]}
                    setting={formFields[formFields.frequencyCapTo.key]}
                    error={errors[formFields.frequencyCapTo.key]}
                    submited={submited}
                    touched={touched[formFields.frequencyCapTo.key]}
                  />
                </div>
              </div>
              {
                !['ion','viads'].includes(props.platformType) && 
                <div className='d-flex justify-content-start align-items-start' >
                <div class="col-md-2 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>Time</label></div>
                <div class="col-md-10 pr-3">
                  <Input
                    onChange={handleChange}
                    onBlur={handleTouch}
                    value={form[formFields.frequencyCapTime.key]}
                    setting={formFields[formFields.frequencyCapTime.key]}
                    error={errors[formFields.frequencyCapTime.key]}
                    submited={submited}
                    touched={touched[formFields.frequencyCapTime.key]}
                  />
                </div>
              </div>
              }
            
  
  
            <div className='d-flex justify-content-start align-items-start' >
              <div class="col-md-2 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>Per</label></div>
              <div class="col-md-10 pr-3">
  
                <SelectNew
                  onChange={handleChange}
                  onBlur={handleTouch}
                  value={form[formFields.frequencyCapPerInterval.key]}
                  setting={formFields[formFields.frequencyCapPerInterval.key]}
                  error={errors[formFields.frequencyCapPerInterval.key]}
                  submited={submited}
                  touched={touched[formFields.frequencyCapPerInterval.key]}
                  options={!['ion','viads'].includes(props.platformType) ? [{ id: 0, name: 'Hours' },
                  { id: 1, name: 'Day' },
                  { id: 2, name: 'Week' },
                  { id: 3, name: 'Month' },
                  { id: 4, name: 'Lifetime' }] : [{ id: 1, name: 'Day' },{id: 4, name: 'Lifetime'}]}
                />
              </div>
            </div>
            </React.Fragment>
                )
              }
            </div>
          </div>





        </div>
      </CSSTransition>




      <CSSTransition
        in={showLocationForm}
        timeout={300}
        classNames="form-transition"
        unmountOnExit
      >
        <LocationSelect
          label="Add Location"
          selectedOptions={selectedLocation}
          onChange={(options) => handleSelectChange(options, "location")}
          onRemove={(removedOption) =>
            handleRemoveOption(removedOption, "location")
          }
          selectedLocation={selectedLocation}
          setSelectedLocation={setSelectedLocation}
          options={locationData}
          placeholderMessage="Search & add location "
          locationApiFunction={locationApiFunction}
          platformType={props.platformType}
          rowData={props.rowData}
          setLocationPayload={setLocationPayload}
          locationPayload={locationPayload}

        />
      </CSSTransition>

      <CSSTransition
        in={showAudienceForm}
        timeout={300}
        classNames="form-transition"
        unmountOnExit
      >
        {/* <div className="aud-adj">
          <SearchSelect
            label="Add Audience"
            selectedOptions={selectedAudience}
            onChange={(options) => handleSelectChange(options, "audience")}
            onRemove={(removedOption) =>
              handleRemoveOption(removedOption, "audience")
            }
            options={audienceData}
            placeholderMessage="Search & add audience "
            apiFunction={audienceApiFunction}
          />
          {renderAudienceColumns()}
        </div> */}

        <div className="col-md-12 audience-set">
          <div className="form-group row mb-0 ">
            <label for="agegroup" class="col-12 col-form-label px-0">
              Add Audience
            </label>
          </div>
          <Input
            onChange={(e) => {
              handleChange(e);
            }}
            onBlur={(e) => {
              handleTouch(e);
            }}
            onKeyDown={(e) => {
              handleKeyDown(e);
            }}
            value={form[formFields.audience.key]}
            setting={formFields[formFields.audience.key]}
            error={errors[formFields.audience.key]}
            submited={submited}
            touched={touched[formFields.audience.key]}
          />
          <div className="d-flex flex-wrap mx-n3">
            {audData.map((dataTag) => {
              return (
                <div className="tagsTab" style={{ textTransform: "capitalize" }}>
                  {dataTag}{" "}
                  <i
                    className="ti ti-x"
                    onClick={() => removeTag(dataTag)}
                    style={{ fontSize: 15, cursor: "pointer" }}
                  ></i>
                </div>
              );
            })}
          </div>
          {renderAudienceColumns()}

        </div>
      </CSSTransition>

      <CSSTransition
        in={showKeywordsForm}
        timeout={300}
        classNames="form-transition"
        unmountOnExit
      >
        {/* <SearchSelect
          label="Search Keywords"
          selectedOptions={selectedKeywords}
          onChange={(options) => handleSelectChange(options, "keywords")}
          onRemove={(removedOption) =>
            handleRemoveOption(removedOption, "keywords")
          }
          options={[
            { value: "technology", label: "Technology" },
            { value: "lifestyle", label: "Lifestyle" },
            { value: "climbing", label: "Climbing" },
            // Add more options as needed
          ]}
          placeholderMessage="Search & add keywords "
          apiFunction={audienceApiFunction}
        /> */}
        <div className="col-md-12 mt-2">
          <div className="form-group row mb-0 ">
            <label for="agegroup" class="col-12 col-form-label px-0">
              Search Keywords
            </label>
          </div>
          <Input
            onChange={(e) => {
              handleChange(e);
            }}
            onBlur={(e) => {
              handleTouch(e);
            }}
            onKeyDown={(e) => {
              handleKeyDown(e);
            }}
            value={form[formFields.keywords.key]}
            setting={formFields[formFields.keywords.key]}
            error={errors[formFields.keywords.key]}
            submited={submited}
            touched={touched[formFields.keywords.key]}
          />
          <div className="d-flex flex-wrap mx-n3">
            {keywordsData.map((dataTag) => {
              return (
                <div className="tagsTab">
                  {dataTag}{" "}
                  <i
                    className="ti ti-x"
                    onClick={() => removeKeywordsTag(dataTag)}
                    style={{ fontSize: 15, cursor: "pointer" }}
                  ></i>
                </div>
              );
            })}
          </div>
        </div>
      </CSSTransition>

      <CSSTransition
        in={showSitesForm}
        timeout={300}
        classNames="form-transition"
        unmountOnExit
      >
        {/* <SearchSelect
          label="Search Sites"
          selectedOptions={selectedSites}
          onChange={(options) => handleSelectChange(options, "sites")}
          onRemove={(removedOption) =>
            handleRemoveOption(removedOption, "sites")
          }
          options={[
            { value: "technology", label: "Technology" },
            { value: "lifestyle", label: "Lifestyle" },
            { value: "climbing", label: "Climbing" },
            // Add more options as needed
          ]}
          placeholderMessage="Search & add sites "
          apiFunction={audienceApiFunction}
        /> */}
        <div className="row">
          <div className="col-md-6 mt-2 px-4">
            <div className="form-group row mb-0 ">
              <label for="agegroup" class="col-12 col-form-label px-0">
                Search Sites
              </label>
            </div>
            <Input
              onChange={(e) => {
                handleChange(e);
              }}
              onBlur={(e) => {
                handleTouch(e);
              }}
              onKeyDown={(e) => {
                handleKeyDown(e);
              }}
              value={form[formFields.sites.key]}
              setting={formFields[formFields.sites.key]}
              error={errors[formFields.sites.key]}
              submited={submited}
              touched={touched[formFields.sites.key]}
            />
            <div className="col d-flex align-items-center mx-n3 pb-3">
              <div className="d-flex align-items-center pr-4">
                <input
                  type="radio"
                  id="whiteList"
                  name="sites"
                  value="whiteList"
                  checked={selectedOptionSites == "whiteList"}
                  onChange={() => {
                    setSelectedOptionSites("whiteList");
                    console.log(selectedOptionSites);
                  }}
                />
                <label htmlFor="whiteList" className="mb-0 pl-2">
                  White list all the sites
                </label>
              </div>
              <div className="d-flex align-items-center">
                <input
                  type="radio"
                  id="blackList"
                  name="sites"
                  value="blackList"
                  checked={selectedOptionSites == "blackList"}
                  onChange={() => {
                    setSelectedOptionSites("blackList");
                    console.log(selectedOptionSites);
                  }}
                />
                <label htmlFor="blackList" className="mb-0 pl-2">
                  Black list all the sites
                </label>
              </div>
            </div>
            <div className="d-flex flex-wrap mx-n3">
              {sitesData.map((dataTag) => {
                return (
                  <div className="tagsTab">
                    {dataTag}{" "}
                    <i
                      className="ti ti-x"
                      onClick={() => removeSitesTag(dataTag)}
                      style={{ fontSize: 15, cursor: "pointer" }}
                    ></i>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="col-md-6 d-flex align-items-center pt-4">

          </div>
        </div>
      </CSSTransition>

      <CSSTransition
        in={showOnScreenPositionForm}
        timeout={300}
        classNames="form-transition"
        unmountOnExit
      >
        <>
          {
            ['ion', 'meta', 'dv360','viads'].includes(props.platformType.toString()) &&
            <div class="accordion mt-3 accordion-bordered details-accordion" id="accordionStyle1">
              <div className="form-group row mb-2">
                <label for="agegroup" class="col-12 col-form-label">
                  Onscreen Position Details
                </label>
              </div>

              {
                props.platformType.toLowerCase() == 'meta' &&
                <div class="accordion-item card mb-0">
                  <h2 class="accordion-header">
                    <button type="button" class="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#accordionStyle1-1" aria-expanded="false">
                      Facebook
                    </button>
                  </h2>

                  <div id="accordionStyle1-1" class="accordion-collapse collapse" data-bs-parent="#accordionStyle1">
                    <div class="accordion-body">
                      <div className='row'>
                        <div className="col-md-12 ">
                          <SelectNew
                            onChange={handleChange}
                            onBlur={handleTouch}
                            value={form[formFields.onScreenFb.key]}
                            setting={formFields[formFields.onScreenFb.key]}
                            error={errors[formFields.onScreenFb.key]}
                            submited={submited}
                            touched={touched[formFields.onScreenFb.key]}
                            options={onScreenPositionDetails.metaOnScreenPositionOptions}
                          />
                        </div>

                        {showFbOptions && (
                          <div className='onScreenFb d-flex flex-row'>
                            <div className="d-flex flex-column">
                              <div className='checkbox-title mb-2'>{onScreenPositionDetails.metaManualPositionOptions.feeds.title}</div>
                              <div className='checkbox-group'>
                                {
                                  onScreenPositionDetails.metaManualPositionOptions.feeds.list.map((item, index) => {
                                    return (
                                      <div key={index} className='checkbox-item'>
                                        <input type="checkbox" checked={onScreenData.some(screenPosition => screenPosition.id == item.id)} onChange={() => handleOnScreenPositions(item)} id={item.id} name={`${item.name}_${item.id}`} />
                                        <label htmlFor={`${item.name}_${item.id}`}>{item.name}</label>
                                      </div>
                                    )
                                  })
                                }
                              </div>
                            </div>

                            <div className="d-flex flex-column pl-5">
                              <div className='checkbox-title mb-2'>{onScreenPositionDetails.metaManualPositionOptions.stories.title}</div>
                              <div className='checkbox-group'>
                                {
                                  onScreenPositionDetails.metaManualPositionOptions.stories.list.map((item, index) => {
                                    return (
                                      <div key={index} className='checkbox-item'>
                                        <input type="checkbox" checked={onScreenData.some(screenPosition => screenPosition.id == item.id)} id={item.id} onChange={() => handleOnScreenPositions(item)} name={`${item.name}_${item.id}`} />
                                        <label htmlFor={`${item.name}_${item.id}`}>{item.name}</label>
                                      </div>
                                    )
                                  })
                                }
                              </div>
                            </div>

                            <div className="d-flex flex-column pl-5">
                              <div className='checkbox-title mb-2'>{onScreenPositionDetails.metaManualPositionOptions.search.title}</div>
                              <div className='checkbox-group'>
                                <div className='checkbox-item'>
                                  {
                                    onScreenPositionDetails.metaManualPositionOptions.search.list.map((item, index) => {
                                      return (
                                        <div key={index} className='checkbox-item'>
                                          <input type="checkbox" id={item.id} checked={onScreenData.some(screenPosition => screenPosition.id == item.id)} onChange={() => handleOnScreenPositions(item)} name={`${item.name}_${item.id}`} />
                                          <label htmlFor={`${item.name}_${item.id}`}>{item.name}</label>
                                        </div>
                                      )
                                    })
                                  }
                                </div>
                              </div>
                            </div>
                          </div>
                        )}


                      </div>
                    </div >
                  </div>
                </div>
              }

              {
                props.platformType.toLowerCase() == 'dv360' &&
                < div class="card accordion-item mb-0">
                  <h2 class="accordion-header">
                    <button type="button" class="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#accordionStyle1-3" aria-expanded="false">
                      DV360
                    </button>
                  </h2>
                  <div id="accordionStyle1-3" class="accordion-collapse collapse" data-bs-parent="#accordionStyle1">
                    <div class="accordion-body">
                      <div className="row onScreenDV">
                        <div className='checkbox-title my-2'>
                          Select position on screen
                        </div>
                        {
                          creativeMappingKeys[props.rowData.type] && creativeMappingKeys[props.rowData.type].includes('display') &&
                          <div className="col-md-3">
                            <p>{onScreenPositionDetails.dv360PositionOptions.onScreen.display.title}</p>
                            {
                              onScreenPositionDetails.dv360PositionOptions.onScreen.display.list.map((item, index) => {
                                return (
                                  <div key={index} className='checkbox-item'>
                                    <input type="checkbox" id={item.id} checked={onScreenData.some(screenPosition => screenPosition.id == item.id)} onChange={() => handleOnScreenPositions(item)} name={`${item.name}_${item.id}`} />
                                    <label htmlFor={`${item.name}_${item.id}`}>{item.name}</label>
                                  </div>
                                )
                              })
                            }
                          </div>
                        }

                        {
                          creativeMappingKeys[props.rowData.type] && creativeMappingKeys[props.rowData.type].includes('video') &&
                          <div className="col-md-3">
                            <p>{onScreenPositionDetails.dv360PositionOptions.onScreen.video.title}</p>
                            {
                              onScreenPositionDetails.dv360PositionOptions.onScreen.video.list.map((item, index) => {
                                return (
                                  <div key={index} className='checkbox-item'>
                                    <input type="checkbox" id={item.id} checked={onScreenData.some(screenPosition => screenPosition.id == item.id)} onChange={() => handleOnScreenPositions(item)} name={`${item.name}_${item.id}`} />
                                    <label htmlFor={`${item.name}_${item.id}`}>{item.name}</label>
                                  </div>
                                )
                              })
                            }
                          </div>
                        }


                        <div className='checkbox-title mb-2 mt-3'>
                          Select position in content
                        </div>
                        {
                          creativeMappingKeys[props.rowData.type] && creativeMappingKeys[props.rowData.type].includes('display') &&
                          <div className="col-md-3">
                            <p>{onScreenPositionDetails.dv360PositionOptions.inContent.inDisplay.title}</p>
                            {
                              onScreenPositionDetails.dv360PositionOptions.inContent.inDisplay.list.map((item, index) => {
                                return (
                                  <div key={index} className='checkbox-item'>
                                    <input type="checkbox" id={item.id} checked={onScreenData.some(screenPosition => screenPosition.id == item.id)} onChange={() => handleOnScreenPositions(item)} name={`${item.name}_${item.id}`} />
                                    <label htmlFor={`${item.name}_${item.id}`}>{item.name}</label>
                                  </div>
                                )
                              })
                            }
                          </div>
                        }

                        {
                          creativeMappingKeys[props.rowData.type] && creativeMappingKeys[props.rowData.type].includes('video') &&
                          <div className="col-md-3">
                            <p>{onScreenPositionDetails.dv360PositionOptions.inContent.videoInStream.title}</p>
                            {
                              onScreenPositionDetails.dv360PositionOptions.inContent.videoInStream.list.map((item, index) => {
                                return (
                                  <div key={index} className='checkbox-item'>
                                    <input type="checkbox" id={item.id} checked={onScreenData.some(screenPosition => screenPosition.id == item.id)} onChange={() => handleOnScreenPositions(item)} name={`${item.name}_${item.id}`} />
                                    <label htmlFor={`${item.name}_${item.id}`}>{item.name}</label>
                                  </div>
                                )
                              })
                            }
                          </div>
                        }

                        {
                          creativeMappingKeys[props.rowData.type] && creativeMappingKeys[props.rowData.type].includes('video') &&
                          <div className="col-md-3">
                            <p>{onScreenPositionDetails.dv360PositionOptions.inContent.videoOutStream.title}</p>
                            {
                              onScreenPositionDetails.dv360PositionOptions.inContent.videoOutStream.list.map((item, index) => {
                                return (
                                  <div key={index} className='checkbox-item'>
                                    <input type="checkbox" id={item.id} checked={onScreenData.some(screenPosition => screenPosition.id == item.id)} onChange={() => handleOnScreenPositions(item)} name={`${item.name}_${item.id}`} />
                                    <label htmlFor={`${item.name}_${item.id}`}>{item.name}</label>
                                  </div>
                                )
                              })
                            }
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              }

              {
                (props.platformType.toLowerCase() == 'ion' || props.platformType.toLowerCase() == 'viads') &&
                <div class="card accordion-item">
                  <h2 class="accordion-header">
                    <button type="button" class="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#accordionStyle1-4" aria-expanded="false">
                      {props.platformType.toLowerCase() == 'ion' ? 'ION' : 'ViAds'}
                    </button>
                  </h2>
                  <div id="accordionStyle1-4" class="accordion-collapse collapse" data-bs-parent="#accordionStyle1">
                    <div class="accordion-body pt-2">
                      <p>Position</p>
                      <Select
                        // options={deviceData}
                        options={onScreenPositionDetails.ionViAdsOnScreenPositionOptions}
                        isMulti={true}
                        placeholder="Select Position"
                        defaultValue={ionViOnScreenData}
                        value={ionViOnScreenData}
                        onChange={(selected) => handleSelectChange(selected, "onScreenPosition")}
                        className="campaignFilter my-2"
                      />
                    </div>
                  </div>
                </div>
              }

            </div >
          }
        </>
      </CSSTransition >

      <CSSTransition
        in={showFlightForm}
        timeout={300}
        classNames="form-transition"
        unmountOnExit
      >
        <div className="form-group row">
          <label for="agegroup" class="col-12 col-form-label pb-3">
            Flight (Dayparting) <span class="text-danger">*</span>
          </label>
          <div className="col d-flex align-items-center">
            <div className="d-flex align-items-center pr-4">
              <input
                type="radio"
                id="allDatesAndDayParts"
                name="flightSchedule"
                value="allDatesAndDayParts"
                checked={selectedOption === "allDatesAndDayParts"}
                onChange={() => setSelectedOption("allDatesAndDayParts")}
              />
              <label htmlFor="allDatesAndDayParts" className="mb-0 pl-2">
                Run on all Dates & Day Parts
              </label>
            </div>
            <div className="d-flex align-items-center">
              <input
                type="radio"
                id="customSchedules"
                name="flightSchedule"
                value="customSchedules"
                checked={selectedOption === "customSchedules"}
                onChange={() => setSelectedOption("customSchedules")}
              />
              <label htmlFor="customSchedules" className="mb-0 pl-2">
                Add Custom Schedules
              </label>
            </div>
          </div>

          {selectedOption === "customSchedules" && (
            <div className="position-relative">
              {dayparts.map((daypart, index) => (
                <div
                  key={index}
                  className="form-group row mt-4 ml-0 position-relative"
                >
                  <div className="col-md-2 px-0">
                    <DatepickerD
                      onChange={(date) =>
                        handleTimeChange(index, "startDate", date)
                      }
                      value={daypart.startDate || ""}
                      onBlur={() => { }}
                      setting={formFeildsDayPart[formFeildsDayPart.startDate.key]}
                      error={errors[formFeildsDayPart.startDate.key]}
                      submited={submited}
                      touched={touched[formFeildsDayPart.startDate.key]}
                      // minDate={new Date()}
                      // maxDate={form.end == "" ? new Date() : form.endDate}
                      minDate={new Date()}
                      maxDate={basicDetailsForm ? basicDetailsForm.endDate : ''}
                      showDisabledMonthNavigation
                      disabled={props.id ? true : false}
                    // other props
                    />
                  </div>
                  <div className="col-md-2 pr-0">
                    <DatepickerD
                      onChange={(date) =>
                        handleTimeChange(index, "endDate", date)
                      }
                      value={daypart.endDate || ""}
                      onBlur={() => { }}
                      setting={formFeildsDayPart[formFeildsDayPart.endDate.key]}
                      error={errors[formFeildsDayPart.endDate.key]}
                      submited={submited}
                      touched={touched[formFeildsDayPart.endDate.key]}
                      isDisabled={form.startDate ? false : true}
                      // minDate={
                      //   props.id
                      //     ? new Date()
                      //     : form.startDate == ""
                      //       ? new Date()
                      //       : form.startDate
                      // }
                      minDate={new Date()}
                      maxDate={basicDetailsForm ? basicDetailsForm.endDate : ''}
                      sDate={form.startDate ? form.startDate : form.sDate ? form.sDate : ""}
                    // sDate={form.startDate}
                    // other props
                    />
                  </div>
                  <div className="col-md-4 pt-2">
                    <label className="mr-2">Select Day</label>
                    <div className=" d-flex align-items-center pt-1">
                      <div
                        className="mx-2 circle-checkbox"
                        onClick={() => handleDayChange(index, "sunday")}
                        style={{
                          backgroundColor: daypart.selectedDays.includes(
                            "sunday"
                          )
                            ? "#303890"
                            : "white",
                          color: daypart.selectedDays.includes("sunday")
                            ? "white"
                            : "#707B8A",
                        }}
                      >
                        S
                      </div>
                      <div
                        className="mx-2 circle-checkbox"
                        onClick={() => handleDayChange(index, "monday")}
                        style={{
                          backgroundColor: daypart.selectedDays.includes(
                            "monday"
                          )
                            ? "#303890"
                            : "white",
                          color: daypart.selectedDays.includes("monday")
                            ? "white"
                            : "#707B8A",
                        }}
                      >
                        M
                      </div>
                      <div
                        className="mx-2 circle-checkbox"
                        onClick={() => handleDayChange(index, "tuesday")}
                        style={{
                          backgroundColor: daypart.selectedDays.includes(
                            "tuesday"
                          )
                            ? "#303890"
                            : "white",
                          color: daypart.selectedDays.includes("tuesday")
                            ? "white"
                            : "#707B8A",
                        }}
                      >
                        T
                      </div>
                      <div
                        className="mx-2 circle-checkbox"
                        onClick={() => handleDayChange(index, "wednesday")}
                        style={{
                          backgroundColor: daypart.selectedDays.includes(
                            "wednesday"
                          )
                            ? "#303890"
                            : "white",
                          color: daypart.selectedDays.includes("wednesday")
                            ? "white"
                            : "#707B8A",
                        }}
                      >
                        W
                      </div>
                      <div
                        className="mx-2 circle-checkbox"
                        onClick={() => handleDayChange(index, "thursday")}
                        style={{
                          backgroundColor: daypart.selectedDays.includes(
                            "thursday"
                          )
                            ? "#303890"
                            : "white",
                          color: daypart.selectedDays.includes("thursday")
                            ? "white"
                            : "#707B8A",
                        }}
                      >
                        T
                      </div>
                      <div
                        className="mx-2 circle-checkbox"
                        onClick={() => handleDayChange(index, "friday")}
                        style={{
                          backgroundColor: daypart.selectedDays.includes(
                            "friday"
                          )
                            ? "#303890"
                            : "white",
                          color: daypart.selectedDays.includes("friday")
                            ? "white"
                            : "#707B8A",
                        }}
                      >
                        F
                      </div>
                      <div
                        className="mx-2 circle-checkbox"
                        onClick={() => handleDayChange(index, "saturday")}
                        style={{
                          backgroundColor: daypart.selectedDays.includes(
                            "saturday"
                          )
                            ? "#303890"
                            : "white",
                          color: daypart.selectedDays.includes("saturday")
                            ? "white"
                            : "#707B8A",
                        }}
                      >
                        S
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3 pt-2">
                    <label className="mr-2">Select Time</label>
                    <div className="d-flex align-items-center mb-3">
                      <input
                        type="time"
                        value={daypart.startTime}
                        onChange={(e) =>
                          handleTimeChange(index, "startTime", e.target.value)
                        }
                        className="form-control mr-2"
                      />
                      <span>-</span>
                      <input
                        type="time"
                        value={daypart.endTime}
                        onChange={(e) =>
                          handleTimeChange(index, "endTime", e.target.value)
                        }
                        className="form-control ml-2"
                      />
                    </div>
                  </div>
                  {index > 0 && (
                    <button
                      className="btn btn-danger delete-circular-btn"
                      onClick={() => handleDeleteRow(index)}
                    >
                      <i className="mdi mdi-delete mr-0"></i>
                    </button>
                  )}
                </div>
              ))}
              <button
                className="btn btn-primary circular-btn-daypart"
                onClick={handleAddRow}
              >
                +
              </button>
            </div>
          )}
        </div>
      </CSSTransition>

      <CSSTransition
        in={showPageForm}
        timeout={300}
        classNames="form-transition"
        unmountOnExit
      >
        <div className="row">
          <div className="form-group row mb-0">
            <label for="agegroup" class="col-12 col-form-label">
              Page (Meta)
              {/* <span class="text-danger">*</span> */}
            </label>
          </div>
          <div className="col-md-6 ">
            <SelectNew
              onChange={handleChange}
              onBlur={handleTouch}
              value={form[formFeildfacebookPageList.fbPageAccount.key]}
              setting={formFeildfacebookPageList[formFeildfacebookPageList.fbPageAccount.key]}
              error={errors[formFeildfacebookPageList.fbPageAccount.key]}
              submited={submited}
              touched={touched[formFeildfacebookPageList.fbPageAccount.key]}
              options={seatData}
            />
          </div>
          <div className="col-md-6 ">
            <SelectNew
              onChange={handleChange}
              onBlur={handleTouch}
              value={form[formFeildfacebookPageList.fbPageList.key]}
              setting={formFeildfacebookPageList[formFeildfacebookPageList.fbPageList.key]}
              error={errors[formFeildfacebookPageList.fbPageList.key]}
              submited={submited}
              touched={touched[formFeildfacebookPageList.fbPageList.key]}
              options={fbPageData}
            />
          </div>
        </div>
      </CSSTransition>

      <div className="strategy-bottom-bar">


        <CSSTransition
          in={!showLocationForm}
          timeout={{ enter: 300, exit: 200 }}
          classNames="button-transition"
          unmountOnExit
        >
          <div
            onClick={() => handleAddFormClick("location", setShowLocationForm)}
          >
            Add Location
          </div>
        </CSSTransition>
        <CSSTransition
          in={!showAudienceForm}
          timeout={{ enter: 400, exit: 200 }}
          classNames="button-transition"
          unmountOnExit
        >
          <div
            onClick={() => handleAddFormClick("audience", setShowAudienceForm)}
          >
            Add Audience
          </div>
        </CSSTransition>
        {(props.platformType != "ion" && props.platformType != "viads") &&

        <CSSTransition
          in={!showKeywordsForm}
          timeout={{ enter: 400, exit: 200 }}
          classNames="button-transition"
          unmountOnExit
        >
          <div
            onClick={() => handleAddFormClick("keywords", setShowKeywordsForm)}
          >
            Add Keywords
          </div>
        </CSSTransition>
        }

        <CSSTransition
          in={!showSitesForm}
          timeout={{ enter: 400, exit: 200 }}
          classNames="button-transition"
          unmountOnExit
        >
          <div
            onClick={() => handleAddFormClick("sites", setShowSitesForm)}
          >
            Add Sites
          </div>
        </CSSTransition>
        <CSSTransition
          in={!showOnScreenPositionForm}
          timeout={{ enter: 400, exit: 200 }}
          classNames="button-transition"
          unmountOnExit
        >
          <>
            {['ion', 'meta', 'dv360','viads'].includes(props.platformType.toString()) &&
              <div onClick={() => handleAddFormClick("onScreenPosition", setShowOnScreenPositionForm)}>
                Onscreen Position Details
              </div>
            }
          </>
        </CSSTransition>
        <CSSTransition
          in={!showFlightForm}
          timeout={{ enter: 400, exit: 200 }}
          classNames="button-transition"
          unmountOnExit
        >
          <div onClick={() => handleAddFormClick("flight", setShowFlightForm)}>
            Flight(Dayparting)
          </div>
        </CSSTransition>
        {
          props.platformType == 'meta' &&
          <CSSTransition
            in={!showPageForm}
            timeout={{ enter: 400, exit: 200 }}
            classNames="button-transition"
            unmountOnExit
          >
            <div onClick={() => handleAddFormClick("page", setShowPageForm)}>
              Page (Meta)
            </div>
          </CSSTransition>

        }

        {
          props.platformType != 'ads' && props.platformType != "meta" &&
          <CSSTransition
            in={!showFrequencyForm}
            timeout={{ enter: 300, exit: 200 }}
            classNames="button-transition"
            unmountOnExit
          >
            <div
              onClick={() => handleAddFormClick("frequency", setShowFrequencyForm)}
            >
              Frequency Capping
            </div>
          </CSSTransition>
        }
      </div>
    </>
  );
};

export default Strategy;